<template>
  <div>
    <div v-if="(crearMultiplesProductosByUdsMedida && localProductosMultiples.length > 1)
      || (productoSeleccionado.MostrarEnListaCON && productoSeleccionado.MostrarEnListaSUPLEMENTO)"
      class="tabs-multiples-productos">
      <div class="tab" :class="{ active: indexProductoActivo === index }"
        v-for="(tab, index) in localProductosMultiples" :key="index" @click="indexProductoActivo = index">
        <div>
          <!-- Mostrar "Formato" + PLU3 si productsDataToFillForm tiene datos, de lo contrario usar udm.unidad -->
          {{ productoSeleccionado.MostrarEnListaCON && productoSeleccionado.MostrarEnListaSUPLEMENTO ? tab.label :
            `Formato ${productsDataToFillForm && productsDataToFillForm.length > 1 ? productsDataToFillForm[index].PLU3 :
              tab.unidad}` }}
          <!--Formato {{ productsDataToFillForm && productsDataToFillForm.length > 1 ? productsDataToFillForm[index].PLU3 : udm.unidad }}-->
          <span v-if="isProductoMultipleCompleto(localProductosMultiples[index].producto, index)"
            style="color: green; font-size: 18px; margin-left: 6px;">●</span>
          <span v-else style="color: red; font-size: 18px; margin-left: 6px;">●</span>
        </div>
      </div>
    </div>

    <div>

    </div>
    <div class="card">
      <div class="card-body">
        <div class="form-layout">
          <!-- Columna 1 -->
          <div class="col-md-6">
            <div class="row">

              <!-- Nombre producto -->
              <div class="col-md-12">
                <div class="form-group">
                  <label for="nameProducto">
                    <strong>{{ $t("nombreProducto") }}
                      <span style="color: red">*</span>
                    </strong>
                  </label>
                  <input type="text" class="form-control" :class="{
                    'is-valid':
                      producto.nombreProducto.length > 0 &&
                      producto.nombreProducto.length <= maxNameProducts,
                    'is-invalid':
                      producto.nombreProducto.length > maxNameProducts,
                  }" id="nameProducto" v-bind:placeholder="$t('introduzcaNombre')" :value="producto.nombreProducto"
                    @input="actualizarCamposComunes" :disabled="true" ref="name" />
                  <input type="hidden" v-model="producto.xname" />

                  <small class="form-text text-muted">
                    {{ producto.nombreProducto.length }}/{{ maxNameProducts }}
                  </small>
                </div>
              </div>

              <!-- Unidad de Medida (Solo para producto simple) -->
              <div class="col-md-12" v-if="isSimpleProductWithUom">
                <div class="form-group">
                  <label>
                    <strong>{{ 'Unidad de Medida' }}</strong> <!-- Fallback string if key missing -->
                  </label>
                  <input type="text" class="form-control"
                    :value="crearMultiplesProductosByUdsMedida && localProductosMultiples && localProductosMultiples.length === 1 ? localProductosMultiples[0].unidad : productoSeleccionado.udMedida[0]"
                    disabled />
                </div>
              </div>

              <!-- Descripción -->
              <div class="col-md-12">
                <div class="form-group">
                  <label for="descripcionProducto"><strong>{{ $t("descripcion") }}</strong></label>
                  <input type="text" class="form-control" id="descripcionProducto"
                    v-bind:placeholder="$t('introduzcaDescripcion')" v-model="producto.descripcion"
                    @input="actualizarCamposComunes" />
                </div>
              </div>

              <!-- Código de Barras -->
              <div class="col-md-12">
                <div class="form-group">
                  <label for="barcodeProducto"><strong>{{ $t("codigoDeBarra") }}</strong></label>
                  <input type="text" class="form-control" id="barcodeProducto"
                    v-bind:placeholder="$t('introduzcaCodigoDeBarras')" v-model="producto.codigoBarras"
                    @input="actualizarCamposComunes" />
                </div>
              </div>
            </div>

            <!-- Color del Botón -->
            <div class="row colors-form">
              <div class="col-md-12">
                <label class="labels">
                  <strong>{{ $t("colorBoton") }}
                    <span style="color: red">*</span>
                  </strong></label>
              </div>
              <div class=" col-md-2 col-4">
                <div class="radio">
                  <label>
                    <input v-model="producto.color" @change="actualizarCamposComunes" type="radio" name="colors"
                      value="amarillo" />
                    <div class="colorWrap" style="background-color: #ffec9f"></div>
                  </label>
                </div>
              </div>

              <div class=" col-md-2 col-4">
                <div class="radio">
                  <label>
                    <input v-model="producto.color" @change="actualizarCamposComunes" type="radio" name="colors"
                      value="rojo" />
                    <div class="colorWrap" style="background-color: #ffbbbb"></div>
                  </label>
                </div>
              </div>

              <div class=" col-md-2 col-4">
                <div class="radio">
                  <label>
                    <input v-model="producto.color" @change="actualizarCamposComunes" type="radio" name="colors"
                      value="verde" />
                    <div class="colorWrap" style="background-color: #c1ffc1"></div>
                  </label>
                </div>
              </div>

              <div class=" col-md-2 col-4">
                <div class="radio">
                  <label>
                    <input v-model="producto.color" @change="actualizarCamposComunes" type="radio" name="colors"
                      value="morado" />
                    <div class="colorWrap" style="background-color: #ffbfff"></div>
                  </label>
                </div>
              </div>

              <div class=" col-md-2 col-4">
                <div class="radio">
                  <label>
                    <input v-model="producto.color" @change="actualizarCamposComunes" type="radio" name="colors"
                      value="blanco" />
                    <div class="colorWrap" style="background-color: #FFFFFF"></div>
                  </label>
                </div>
              </div>

              <div class=" col-md-2 col-4">
                <div class="radio">
                  <label>
                    <input v-model="producto.color" @change="actualizarCamposComunes" type="radio" name="colors"
                      value="azul" />
                    <div class="colorWrap" style="background-color: #cad3ff"></div>
                  </label>
                </div>
              </div>

              <div class=" col-md-2 col-4">
                <div class="radio">
                  <label>
                    <input v-model="producto.color" @change="actualizarCamposComunes" type="radio" name="colors"
                      value="naranja" />
                    <div class="colorWrap" style="background-color: #ffa54a"></div>
                  </label>
                </div>
              </div>

              <div class=" col-md-2 col-4">
                <div class="radio">
                  <label>
                    <input v-model="producto.color" @change="actualizarCamposComunes" type="radio" name="colors"
                      value="gris" />
                    <div class="colorWrap" style="background-color: #bbbbbb"></div>
                  </label>
                </div>
              </div>

              <div class=" col-md-2 col-4">
                <div class="radio">
                  <label>
                    <input v-model="producto.color" @change="actualizarCamposComunes" type="radio" name="colors"
                      value="negro" />
                    <div class="colorWrap" style="background-color: #000000"></div>
                  </label>
                </div>
              </div>
            </div>
            <br>
          </div>

          <!-- Segunda columna (a partir de Tarifa 1) -->
          <div class="col-md-6">

            <!-- Tarifa 1 -->
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <label class="labels" for="namePrice1">
                    <strong>{{ $t("tarifa1") }}</strong>
                  </label>
                </div>

                <div class="col-md-1 col-1">
                  <!-- <input type="checkbox" name="selPrice1" id="selPrice1" style="margin-top: 6px;"
                    v-model="producto.selPrice1" @change="actualizarCamposComunes" class="custom-checkbox"
                    :disabled="tarifasBloqueadas" /> -->
                  <input type="checkbox" name="selPrice1" id="selPrice1" style="margin-top: 6px;"
                    v-model="producto.selPrice1" @change="actualizarCamposComunes" class="custom-checkbox"
                    :disabled="true" />
                </div>
                <div class="col-md-10 col-10">
                  <div class="form-group">
                    <!-- <input type="text" class="form-control" id="namePrice1" v-bind:placeholder="$t('tarifa1')"
                      v-model="producto.namePrice1" @input="actualizarNombreTarifa" :disabled="tarifasBloqueadas" /> -->
                    <input type="text" class="form-control" id="namePrice1" v-bind:placeholder="$t('tarifa1')"
                      v-model="producto.namePrice1" @input="actualizarNombreTarifa" :disabled="true" />
                  </div>
                </div>
              </div>
            </div>

            <!-- Tarifa 2 -->
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <label class="labels" for="namePrice2"><strong>{{ $t("tarifa2") }}</strong></label>
                </div>
                <div class="col-md-1 col-1">
                  <!-- <input type="checkbox" name="selPrice2" id="selPrice2" style="margin-top:6px;"
                    v-model="producto.selPrice2" @change="actualizarCamposComunes" class="custom-checkbox"
                    :disabled="tarifasBloqueadas" /> -->
                  <input type="checkbox" name="selPrice2" id="selPrice2" style="margin-top:6px;"
                    v-model="producto.selPrice2" @change="actualizarCamposComunes" class="custom-checkbox"
                    :disabled="true" />
                </div>
                <div class="col-md-10 col-10">
                  <div class="form-group">
                    <!-- <input type="text" class="form-control" id="namePrice2" v-bind:placeholder="$t('tarifa2')"
                      v-model="producto.namePrice2" @input="actualizarNombreTarifa" :disabled="tarifasBloqueadas" /> -->

                    <input type="text" class="form-control" id="namePrice2" v-bind:placeholder="$t('tarifa2')"
                      v-model="producto.namePrice2" @input="actualizarNombreTarifa" :disabled="true" />
                  </div>
                </div>
              </div>
            </div>

            <!-- Tarifa 3 -->
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <label class="labels" for="namePrice3"><strong>{{ $t("tarifa3") }}</strong></label>
                </div>
                <div class="col-md-1 col-1">
                  <!-- <input type="checkbox" name="selPrice3" id="selPrice3" style="margin-top:6px;"
                    v-model="producto.selPrice3" @change="actualizarCamposComunes" class="custom-checkbox"
                    :disabled="tarifasBloqueadas" /> -->
                  <input type="checkbox" name="selPrice3" id="selPrice3" style="margin-top:6px;"
                    v-model="producto.selPrice3" @change="actualizarCamposComunes" class="custom-checkbox"
                    :disabled="true" />
                </div>
                <div class="col-md-10 col-10">
                  <div class="form-group">
                    <!-- <input type="text" class="form-control" id="namePrice3" v-bind:placeholder="$t('tarifa3')"
                      v-model="producto.namePrice3" @input="actualizarNombreTarifa" :disabled="tarifasBloqueadas" /> -->
                    <input type="text" class="form-control" id="namePrice3" v-bind:placeholder="$t('tarifa3')"
                      v-model="producto.namePrice3" @input="actualizarNombreTarifa" :disabled="true" />
                  </div>
                </div>
              </div>
            </div>

            <!-- Tarifa 4 -->
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <label class="labels" for="namePrice4"><strong>{{ $t("tarifa4") }}</strong></label>
                </div>
                <div class="col-md-1 col-1">
                  <!-- <input type="checkbox" name="selPrice4" id="selPrice4" style="margin-top:6px;"
                    v-model="producto.selPrice4" @change="actualizarCamposComunes" class="custom-checkbox"
                    :disabled="tarifasBloqueadas" /> -->
                  <input type="checkbox" name="selPrice4" id="selPrice4" style="margin-top:6px;"
                    v-model="producto.selPrice4" @change="actualizarCamposComunes" class="custom-checkbox"
                    :disabled="true" />
                </div>
                <div class="col-md-10 col-10">
                  <div class="form-group">
                    <!-- <input type="text" class="form-control" id="namePrice4" v-bind:placeholder="$t('tarifa4')"
                      v-model="producto.namePrice4" @input="actualizarNombreTarifa" :disabled="tarifasBloqueadas" /> -->

                    <input type="text" class="form-control" id="namePrice4" v-bind:placeholder="$t('tarifa4')"
                      v-model="producto.namePrice4" @input="actualizarNombreTarifa" :disabled="true" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Parte 2 del Form: Tarifas, Orden, Baja, Descuento y Menú -->
        <div class="form-layout">
          <div class="col-md-12">
            <div class="row">

              <!-- Título y Checkbox de Tarifas por departamento/tpv -->
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <label class="labels" style="margin-left: 15px;"><strong>{{ $t("CategoriayTarifasPorDepartamento")
                    }}</strong></label>
                  </div>
                  <div class="col-md-6 d-flex justify-content-end align-items-center">
                    <input type="checkbox" id="replicarTarifas" style="margin-right: 10px;"
                      v-model="producto.replicarTarifas" class="custom-checkbox" />
                    <label class="labels" style="margin-right: 15px;"><strong>{{
                      $t("replicarValoresTarifasEnTodaLaColumnaCheckbox") }}</strong></label>
                  </div>
                </div>
              </div>


              <!-- Alert Info, Tabla de Tarifas, Orden, Baja, Descuento y Menu-->
              <div class="col-md-12">

                <!-- Alert -->
                <div class="col-md-12">
                  <div class="alert alert-info" role="alert">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    <label class="labels"
                      v-html="$t('completarTarifasBusinessCentralAlertInfo', { PRODUCT_NAME: this.productoSeleccionado.productName })"></label>
                  </div>
                </div>

                <!-- Tabla -->
                <div class="col-md-12">
                  <div class="table-container">
                    <table class="product-table">
                      <thead>
                        <tr>
                          <th>{{ $t("departamento") }}</th>
                          <th>{{ $t("categoria") }}
                            <span style="color: red">*</span>
                          </th>
                          <th>{{ $t("iva") }}
                            <span style="color: red">*</span>
                          </th>
                          <th v-for="(header, index) in namePriceHeaders" :key="index">
                            {{ header }}
                          </th>
                          <th>{{ $t("categoriaEnlazada") }}</th>

                        </tr>
                      </thead>
                      <!-- Para replicar valores, asociamos el método updateTarifaValue al campo de input vue-numeric de las celdas de la tabla. Y mandamos como parámetros:
                        - El tpv del que estamos hablando.
                        - La tarifa de la que estamos hablando (price1, price2…)
                        - El nuevo valor ingresado en la celda.
                      -->
                      <tbody>

                        <tr v-for="tpv in selectedTpvServerList" :key="tpv.idTpvServer">
                          <td>{{ tpv.nameShow }}</td>

                          <!-- Selector de Categoría por cada TPV -->
                          <td>
                            <el-select class="select-default" size="small"
                              v-model="getProductoForTpv(tpv.idTpvServer).idCategory" filterable
                              :placeholder="$t('seleccionaCategoria')" :disabled="categoriasBloqueadas"
                              @change="updateCategoryForTpv(tpv.idTpvServer, $event)">
                              <el-option v-for="category in getCategoriesForTPV(tpv.idTpvServer)" class="select-primary"
                                :value="category.id" :label="category.name" :key="category.id">
                              </el-option>
                            </el-select>
                          </td>

                          <!-- Selector de IVA por cada TPV -->
                          <td>
                            <el-select class="select-default" size="small"
                              v-model="getProductoForTpv(tpv.idTpvServer).tipoIva" :placeholder="$t('seleccionaIVA')"
                              @change="updateIvaForTpv(tpv.idTpvServer, parseInt($event))">
                              <el-option v-for="iva in getIvaForTPV(tpv.idTpvServer)" class="select-primary"
                                :key="iva.id" :value="iva.value" :label="iva.label">
                              </el-option>
                            </el-select>
                          </td>

                          <td v-for="index in 4" :key="index">
                            <vue-numeric currency="€" inputmode="decimal" class="form-control"
                              currency-symbol-position="suffix" :precision="2"
                              v-model="getProductoForTpv(tpv.idTpvServer)['price' + index]"
                              @input="updateTarifaValue(getProductoForTpv(tpv.idTpvServer), 'price' + index, $event)"
                              @keydown.native="evitarComasDecimales" @focus.native="selectAll($event)"
                              :disabled="index > numTarifasActivas" />
                          </td>
                          <!-- Selector de Categoría enlazada por cada TPV -->
                          <!-- <td>

                            <el-select class="select-default" size="small"
                              v-model="getCategoriaEnlazada(tpv.idTpvServer).grupo_enlazado" filterable
                              :placeholder="$t('seleccionaCategoria')"
                              @change="updateLinkedCategoryForTpv(tpv.idTpvServer, $event)">
              
                              <el-option v-if="!getProductoForTpv(tpv.idTpvServer).idCategory" :value="null"
                                :label="$t('seleccionaPreviamenteCategoria')" disabled />

                              
                              <el-option
                                v-for="category in getCategoriesForTPV(tpv.idTpvServer).filter(c => c.id !== getProductoForTpv(tpv.idTpvServer).idCategory)"
                                v-else class="select-primary" :value="category.id" :label="category.name"
                                :key="category.id" />
                            </el-select>
                          </td> -->

                          <td>
                            <!-- Categoría enlazada de ESTE TPV: solo lista las categorías del TPV de la fila.
                                 Mientras no haya categoría principal el selector va deshabilitado y el tooltip explica por qué. -->
                            <el-tooltip effect="dark" placement="top"
                              :content="$t('seleccionaPreviamenteCategoria')"
                              :disabled="categoriasBloqueadas || !!getProductoForTpv(tpv.idTpvServer).idCategory">
                              <div class="grupo-enlazado-wrapper">
                                <el-select
                                  :key="`grupo-${tpv.idTpvServer}-${getProductoForTpv(tpv.idTpvServer).grupo_enlazado}`"
                                  v-model="grupoEnlazadoByTpv(tpv.idTpvServer).value" class="select-default" size="small"
                                  filterable clearable @clear="grupoEnlazadoByTpv(tpv.idTpvServer).value = null"
                                  :placeholder="!getProductoForTpv(tpv.idTpvServer).idCategory
                                    ? $t('seleccionaPreviamenteCategoria')
                                    : $t('seleccionaCategoria')"
                                  :disabled="categoriasBloqueadas || !getProductoForTpv(tpv.idTpvServer).idCategory">
                                  <el-option :value="null" label="Sin categoría" />

                                  <el-option v-for="category in getCategoriesForTPV(tpv.idTpvServer, true).filter(c =>
                                    Number(c.id) !== Number(getProductoForTpv(tpv.idTpvServer).idCategory) ||
                                    Number(c.id) === Number(getProductoForTpv(tpv.idTpvServer).grupo_enlazado)
                                  )" :key="category.id" :value="Number(category.id)" :label="category.name" />

                                </el-select>
                              </div>
                            </el-tooltip>
                            <!-- PARA DEBUGEAR -->
                            <!-- <div v-if="getProductoForTpv(tpv.idTpvServer).grupo_enlazado" class="mt-2">
                              <strong>Categoría seleccionada:</strong> {{ getCategoriaEnlazada(tpv.idTpvServer) }}
                            </div> -->
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- Orden -->
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="orden"><strong>{{ $t("orden") }}</strong></label>
                    <input type="number" class="form-control" id="orden"
                      v-bind:placeholder="producto.orden === 999 ? '999' : ''" @input="actualizarCamposComunes" min="0"
                      v-model="producto.orden" />
                  </div>
                </div>

                <!-- Baja -->
                <div class="col-md-12" style="margin-top: 20px">
                  <div class="form-group">
                    <label>
                      <strong>{{ $t("baja") }}</strong>
                    </label>
                    <sup>
                      <i v-tooltip.top-center="$i18n.t(
                        'alDarUnProductoDeBajaDesapareceEnElTPVParaSuVentaPeroSigueApareciendoEnLosInformesDeVenta'
                      )
                        " class="fa fa-question-circle"></i>
                    </sup>
                    <el-switch v-model="producto.baja" @change="actualizarCamposComunes" active-color="#13ce66"
                      inactive-color="#bcbcbc" :disabled="true">
                    </el-switch>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueNumeric from 'vue-numeric';
import {
  Select,
  Option,
  Checkbox,
  Switch,
  Input,
  Tooltip,
} from "element-ui";
import Swal from "sweetalert2";
import { Loading } from 'element-ui';
import { prod } from 'mathjs';

export default {
  props: {
    productoSeleccionado: Object,
    selectedTpvServerList: Array,
    // Lista de todas las categorías de todos los TPVs, luego filtramos por selectedTpvServerList
    listCategoriesByBusiness: Array,

    finalizeButtonPressed: Boolean,
    moveBackButtonPressed: Boolean,
    productosPorTpvRecuperados: {
      type: [Object, Array],
      default: () => ({})
    },
    crearMultiplesProductosByUdsMedida: Boolean,
    productosMultiples: Array,
    continueButtonPressedOnStep3: Boolean,
    productsDataToFillForm: Array,
    resetProductoFormBasico: Boolean,
    activeDepartments: {
      type: Array,
      default: () => []
    },
    productDataInfo: {
      type: Object,
      default: () => ({})
    }
  },

  created() {
    // console.log('[PF-Basico][created] productosMultiples recibidos desde parent:', this.productosMultiples)

    if (this.productosMultiples && this.productosMultiples.length > 1) {

      this.productosMultiples.forEach(pm => {

        let nombreFinal = pm.producto.nombreProducto
        let udMedidaFinal = []

        const nuevoProducto = {
          ...pm.producto,
          nombreProducto: nombreFinal,
          udMedida: udMedidaFinal,
          multiProductoIndex: pm.producto.multiProductoIndex || 0
        }

        this.localProductosMultiples.push({
          unidad: pm.unidad,
          producto: nuevoProducto
        })

      })

    }
  },

  mounted() {
    // console.log(" > productoSeleccionado recibido en ProductoFormBasico:", this.productoSeleccionado);
    // console.log(" > selectedTpvServerList recibida en ProductoFormBasico:", this.selectedTpvServerList);
    // console.log(" > listCategoriesByBusiness recibida en ProductoFormBasico", this.listCategoriesByBusiness)
    // console.log(" > productsDataToFillForm recibido en ProductoFormBasico", this.productsDataToFillForm)

    // Rellenamos el selector de categorias por Tpv
    this.getCategoryListBySelectedTpvServerList();

    // console.log(" > El prod to fill form", (this.productsDataToFillForm)); 

    // Si tenemos datos en productsDataToFillForm es que estamos en modo actualizar producto. Asignamos todos los valores obtenidos a productosPorTpv
    if (this.productsDataToFillForm.length > 0) {
      const seenTpvUnit = new Set();
      this.productosPorTpv = this.productsDataToFillForm.filter(prod => {
        const key = `${prod.idTpv}_${prod.PLU3 || "Simple"}`;
        if (!seenTpvUnit.has(key)) {
          seenTpvUnit.add(key);
          return true;
        }
        return false;
      });
      // console.log(" > productosPorTpv rellenado a partir de productsDataToFillForm", this.productosPorTpv)
    }

    // Estamos en actualizar, vamos a pre-completar el form
    if (this.productsDataToFillForm.length > 0) {
      // console.log("> Vamos a rellenar los datos");
      this.fillFormByProductData()
    }

    // console.log("this.productoSeleccionado", this.productoSeleccionado);
    // console.log("this.productosPorTpvRecuperados", this.productosPorTpvRecuperados);
    // console.log(this.crearMultiplesProductosByUdsMedida);
    // Cuando el componente se monta, si detectamos que estamos en el caso 3, creamos las copias del producto.
    if (
      this.crearMultiplesProductosByUdsMedida &&
      this.productoSeleccionado &&
      Array.isArray(this.productoSeleccionado.udMedida) &&
      this.productoSeleccionado.udMedida.length > 0 &&
      !this.productosPorTpvRecuperados.length > 0
    ) {
      console.log("[PF-Basico][mounted] Configurando múltiples productos por Uds. de Medida");
      // Si ya tenemos datos pre-rellenados (caso 1), respetarlos
      if (this.localProductosMultiples && this.localProductosMultiples.length > 0) {
        this.indexProductoActivo = 0;
        const activeProducto = this.localProductosMultiples[0].producto;
        console.log("[PF-Basico][mounted] Producto activo (tab 0) con precios:", { p1: activeProducto.price1, p2: activeProducto.price2, p3: activeProducto.price3, p4: activeProducto.price4 });
        this.producto = {
          ...this.producto,
          nombreProducto: activeProducto.nombreProducto || "",
          descripcion: activeProducto.descripcion || "",
          codigoBarras: activeProducto.codigoBarras || "",
          color: activeProducto.color || "",
          price1: activeProducto.price1 || 0,
          price2: activeProducto.price2 || 0,
          price3: activeProducto.price3 || 0,
          price4: activeProducto.price4 || 0,
          selPrice1: activeProducto.selPrice1 || false,
          selPrice2: activeProducto.selPrice2 || false,
          selPrice3: activeProducto.selPrice3 || false,
          selPrice4: activeProducto.selPrice4 || false,
          namePrice1: activeProducto.namePrice1 || "",
          namePrice2: activeProducto.namePrice2 || "",
          namePrice3: activeProducto.namePrice3 || "",
          namePrice4: activeProducto.namePrice4 || "",
        };
        // Asegurar que productosPorTpv se inicializa con estos valores (incluyendo precios)
        this.inicializarProductosPorTpv();
        if (this.productosPorTpv && this.productosPorTpv.length > 0) {
          const s = this.productosPorTpv.slice(0, 3).map(p => ({ tpv: p.idTpvServer, idx: p.multiProductoIndex, p1: p.price1 }));
          console.log('[PF-Basico][mounted] productosPorTpv despues de inicializar con precios:', s);
        }
      } else {
        console.log("[PF-Basico][mounted] Inicializando productos múltiples por Uds. de Medida con valores vacíos");

        // Si no, inicializar con productos vacíos por defecto
        this.localProductosMultiples = this.productoSeleccionado.udMedida.map((ud, i) => ({
          unidad: ud,
          producto: {
            nombreProducto: this.productoSeleccionado.udMedida.length > 1 ? `${this.productoSeleccionado.productName} ${ud}` : this.productoSeleccionado.productName,
            descripcion: "",
            codigoBarras: "",
            color: "amarillo",
            price1: 0,
            price2: 0,
            price3: 0,
            price4: 0,
            selPrice1: false,
            selPrice2: false,
            selPrice3: false,
            selPrice4: false,
            namePrice1: "",
            namePrice2: "",
            namePrice3: "",
            namePrice4: "",
            idTpvServer: null,
            multiProductoIndex: i
          }
        }));
        this.indexProductoActivo = 0;

        // Actualizar explícitamente this.producto con los datos de la primera pestaña
        const activeProducto = this.localProductosMultiples[0].producto;
        this.producto = {
          ...this.producto,
          nombreProducto: activeProducto.nombreProducto || "",
          descripcion: activeProducto.descripcion || "",
          codigoBarras: activeProducto.codigoBarras || "",
          color: activeProducto.color || "",
          price1: activeProducto.price1 || 0,
          price2: activeProducto.price2 || 0,
          price3: activeProducto.price3 || 0,
          price4: activeProducto.price4 || 0,
          selPrice1: activeProducto.selPrice1 || false,
          selPrice2: activeProducto.selPrice2 || false,
          selPrice3: activeProducto.selPrice3 || false,
          selPrice4: activeProducto.selPrice4 || false,
          namePrice1: activeProducto.namePrice1 || "",
          namePrice2: activeProducto.namePrice2 || "",
          namePrice3: activeProducto.namePrice3 || "",
          namePrice4: activeProducto.namePrice4 || "",
        };

      }

    }

    // Llamar a configTarifasByUdsMedida al montar el componente si detectamos que crearMultiplesProductosByUdsMedida tiene algun valor distinto a undefined (sea false para el caso 2, o true para el caso 3)
    if (this.productoSeleccionado && this.crearMultiplesProductosByUdsMedida !== undefined) {
      console.log("Llamar a configTarifasByUdsMedida");
      this.configTarifasByUdsMedida();
    }

    if (
      this.categoryListBySelectedTpvServerList &&
      this.categoryListBySelectedTpvServerList.length > 0 &&
      this.productoSeleccionado &&
      (this.productoSeleccionado.MostrarEnListaCON || this.productoSeleccionado.MostrarEnListaSUPLEMENTO)
    ) {
      this.configFormByListaCONySUPLEMENTO();
    }

    // console.log("mounted al final - por tpv", this.productosPorTpv);
    // console.log("mounted al final - prod seleccionado", this.productoSeleccionado);
    // console.log("mounted al final - prod", this.producto);
  },

  computed: {
    productoActivo() {
      if (this.crearMultiplesProductosByUdsMedida && this.localProductosMultiples.length > 0) {
        return this.localProductosMultiples[this.indexProductoActivo].producto;
      }
      return this.productoSeleccionado;
    },

    nombreProductoInicial() {
      if (this.crearMultiplesProductosByUdsMedida && this.localProductosMultiples.length > 0) {
        return this.localProductosMultiples[this.indexProductoActivo].producto.nombreProducto;
      }
      return this.productoSeleccionado.productName || '';
    },

    namePriceHeaders() {
      const p = this.producto;

      return [
        p.namePrice1 || this.$t("tarifa1"),
        p.namePrice2 || this.$t("tarifa2"),
        p.namePrice3 || this.$t("tarifa3"),
        p.namePrice4 || this.$t("tarifa4"),
      ];
    },
    grupoEnlazadoByTpv() {
      const self = this;

      return function (tpvId) {
        return {
          get value() {
            const producto = self.getProductoForTpv(tpvId);
            if (producto.grupo_enlazado === "0" || producto.grupo_enlazado === 0 || producto.grupo_enlazado === "") {
              return null;
            } else {
              return producto && producto.grupo_enlazado != null
                ? Number(producto.grupo_enlazado)
                : null;
            }
          },
          set value(val) {
            self.updateLinkedCategoryForTpv(tpvId, val);
          }
        };
      };
    },

    // Computed property to detect simple products with a single UOM
    isSimpleProductWithUom() {
      const isNormalSimple = !this.crearMultiplesProductosByUdsMedida &&
        this.productoSeleccionado &&
        Array.isArray(this.productoSeleccionado.udMedida) &&
        this.productoSeleccionado.udMedida.length === 1;

      const isFormatToSimple = this.crearMultiplesProductosByUdsMedida &&
        this.localProductosMultiples &&
        this.localProductosMultiples.length === 1;

      return isNormalSimple || isFormatToSimple;
    },
  },
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Checkbox.name]: Checkbox,
    [Switch.name]: Switch,
    [Input.name]: Input,
    [Tooltip.name]: Tooltip,
    VueNumeric,
  },
  data() {
    return {
      productosPorTpv: [],
      maxNameProducts: 75,
      producto: {
        id: 0,
        orden: 999,
        idCategory: null,
        grupo_enlazado: null,
        tipoIva: 0, // Tipo de IVA según el producto, se autocompleta con el método watch
        xname: "",
        nombreProducto: "", // Nombre del producto, se autocompleta con el método watch
        descripcion: "",
        codigoBarras: "",
        color: "amarillo", // Color por defecto
        baja: false,
        descuento: false,
        isMenu: false,
        isClosed: false,
        selPrice1: false,
        selPrice2: false,
        selPrice3: false,
        selPrice4: false,
        namePrice1: "",
        namePrice2: "",
        namePrice3: "",
        namePrice4: "",
        price1: 0,
        price2: 0,
        price3: 0,
        price4: 0
      },
      categoryListBySelectedTpvServerList: [],
      listIva: [],


      inSavingProgress: false,
      platos: [
        { nombrePlato: "", idPlato: 1 },
        { nombrePlato: "", idPlato: 2 },
        { nombrePlato: "", idPlato: 3 },
        { nombrePlato: "", idPlato: 4 },
        { nombrePlato: "", idPlato: 5 },
        { nombrePlato: "", idPlato: 6 },
      ],
      loadingGeneral: null,
      indexProductoActivo: 0,
      localProductosMultiples: [], // Version local de la prop productosMultiples
      tarifasBloqueadas: false, // Flag para controlar el bloqueo de campos
      numTarifasActivas: 4, // Número de tarifas activas (por defecto 4)

      // IVAs estándar cuando el TPV no los tiene configurados en la tabla tpvs.
      // Son los mismos que ProductoFormCompleto pinta por defecto.
      ivasPorDefecto: [4, 10, 21],
      // IVA que se preselecciona cuando Business Central no manda ninguno válido.
      ivaPorDefectoSinDato: 10,
      categoriasBloqueadas: false,

      //BUSINESS CENTRAL
      businessCentral: false,
      restriccionBusinessCentral: false,

      //CompanyConfigs
      companyConfigs: [],
      idCompany: 0,
    };
  },
  watch: {
    // Observa cambios en la prop productoSeleccionado y actualiza el campo nombreProducto, y el desplegable con el tipo de IVA
    productoSeleccionado: {
      immediate: true,
      handler(newProducto) {
        if (!newProducto) return;

        if (this.crearMultiplesProductosByUdsMedida && Array.isArray(newProducto.udMedida) && newProducto.udMedida.length > 1) {
          this.producto.nombreProducto = newProducto.productName + " " + newProducto.udMedida[0] || "";
        }
        else {
          this.producto.nombreProducto = newProducto.productName || "";
        }

        this.productosPorTpv.forEach(producto => {
          producto.nombreProducto = newProducto.productName || "";
        });

        if (this.crearMultiplesProductosByUdsMedida && Array.isArray(newProducto.udMedida) && newProducto.udMedida.length > 0) {

          // Si el padre ya entregó productosMultiples con varias unidades, el hook created() los gestiona.
          // Evitar doble-inicialización porque immediate:true corre ANTES que created()
          if (this.productosMultiples && this.productosMultiples.length > 1) {
            this.indexProductoActivo = 0;
            return;
          }

          const existingPricesMap = {};

          const firstTpvId = this.productDataInfo && this.productDataInfo.tpvs ? Object.keys(this.productDataInfo.tpvs)[0] : null;
          const productoData = firstTpvId && this.productDataInfo.tpvs[firstTpvId] &&
            this.productDataInfo.tpvs[firstTpvId].productos &&
            this.productDataInfo.tpvs[firstTpvId].productos[0] ?
            this.productDataInfo.tpvs[firstTpvId].productos[0].producto : null;

          if (productoData) {
            for (let k = 1; k <= 4; k++) {
              const npm = productoData[`namePrice${k}`];
              const pr = productoData[`price${k}`];
              if (npm && npm.trim() !== "") {
                existingPricesMap[npm.trim().toUpperCase()] = Number(pr) || 0;
              }
            }

            if (this.productDataInfo.tpvs[firstTpvId] && this.productDataInfo.tpvs[firstTpvId].productos) {
              this.productDataInfo.tpvs[firstTpvId].productos.forEach(pw => {
                const p = pw.producto || pw;
                if (p && p.PLU3) {
                  const udKey = p.PLU3.trim().toUpperCase();
                  existingPricesMap[udKey] = Number(p.price1) || 0;
                  existingPricesMap[`${udKey}_categoryId`] = p.idCategory || null;
                }
              });
            }

            if (Object.keys(existingPricesMap).length === 0 && productoData.price1) {
              const fallbackUnit = (productoData.PLU4 || "").trim().toUpperCase();
              if (existingPricesMap[fallbackUnit] === undefined) {
                existingPricesMap[fallbackUnit] = Number(productoData.price1) || 0;
              }
            }
          }

          const isTariff = newProducto.changeFormatToRates === 1;

          this.localProductosMultiples = newProducto.udMedida.map((ud, i) => {
            const unitKey = ud.trim().toUpperCase();
            const mappedPrice = existingPricesMap[unitKey] !== undefined ? existingPricesMap[unitKey] : 0;
            const mappedCategoryId = existingPricesMap[`${unitKey}_categoryId`] !== undefined ? Number(existingPricesMap[`${unitKey}_categoryId`]) : null;

            return {
              unidad: ud,
              producto: {
                nombreProducto: newProducto.udMedida.length > 1 ? `${newProducto.productName} ${ud}` : newProducto.productName,
                descripcion: "",
                codigoBarras: "",
                color: "amarillo",
                selPrice1: isTariff && mappedPrice > 0, // Solo para Tarifa: marcar si tiene precio
                selPrice2: false,
                selPrice3: false,
                selPrice4: false,
                namePrice1: "",
                namePrice2: "",
                namePrice3: "",
                namePrice4: "",
                ...(mappedCategoryId !== null && { idCategory: mappedCategoryId }),
                idTpvServer: null,
                multiProductoIndex: i,
                price1: mappedPrice,
                price2: 0,
                price3: 0,
                price4: 0
              }
            };
          });
          this.indexProductoActivo = 0;
        }
        else {
          this.localProductosMultiples = [];
        }
      }
    },

    listCategoriesByBusiness: {
      immediate: true,
      handler(newList) {
        if (newList && newList.length > 0) {

          this.getCategoryListBySelectedTpvServerList();
        }
      }
    },

    productDataInfo: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.tpvs) {
          // console.log(" > productDataInfo recibida, re-mapeando categorías y selecciones...");
          this.getCategoryListBySelectedTpvServerList();
        }
      },
      deep: true
    },

    listIva: {
      immediate: true,
      handler(newList) {

        this.listIva = newList || [];

      }
    },


    finalizeButtonPressed(newValue) {
      if (newValue) {
        // console.log(" > finalizeButtonPressed.", this.productosPorTpv);
      }
    },

    moveBackButtonPressed(newValue) {
      if (newValue) {
        // console.log(" > Enviando productosPorTpv al step 2:", this.productosPorTpv);
        this.$emit('move-back-to-step2', this.productosPorTpv);
      }
    },

    // Cuando pulsamos en el step3 en Continuar, hay 2 flujos. Ambos de checkbarcode, solo que si el flujo es actualizandoProductos, 
    // se va a permitir que un mismo producto tenga el mismo barcode que tenía guardado
    continueButtonPressedOnStep3(newValue) {
      if (newValue) {
        // console.log(" > Intentando continuar en Step3, hacemos checkBarCodeProd");
        this.checkBarCodeProd();
      }
    },

    resetProductoFormBasico(newValue) {
      if (newValue) {
        // console.log(" > Recibimos un nuevo value en resetProductoFormBasico, llamamos a resetFormn");
        this.resetForm();
      }
    },

    productosPorTpvRecuperados: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          const primerProducto = newVal[0];
          const todosSonSimple = newVal.every(p => p.PLU2 === "Simple");

          // Caso 1: Todos son Simple
          if (todosSonSimple) {
            // console.log(" > Caso 1: Todos son Simple");
            this.producto = {
              ...this.producto,
              nombreProducto: primerProducto.nombreProducto || primerProducto.name || "",
              descripcion: primerProducto.descripcion || primerProducto.description || "",
              codigoBarras: primerProducto.codigoBarras || primerProducto.barCode || "",
              color: primerProducto.color || "amarillo",
              selPrice1: primerProducto.selPrice1 == "1",
              selPrice2: primerProducto.selPrice2 == "1",
              selPrice3: primerProducto.selPrice3 == "1",
              selPrice4: primerProducto.selPrice4 == "1",
              namePrice1: primerProducto.namePrice1 || "",
              namePrice2: primerProducto.namePrice2 || "",
              namePrice3: primerProducto.namePrice3 || "",
              namePrice4: primerProducto.namePrice4 || "",
              orden: primerProducto.orden || primerProducto.orderCode || 999,
              baja: primerProducto.baja || false,
              descuento: primerProducto.descuento || false,
              isMenu: primerProducto.isMenu || false,
              isClosed: primerProducto.isClosed || false,
              price1: Number(primerProducto.price1) || 0,
              price2: Number(primerProducto.price2) || 0,
              price3: Number(primerProducto.price3) || 0,
              price4: Number(primerProducto.price4) || 0,
            };


            const seenTpvUnit = new Set();
            const deDuplicatedVal = newVal.filter(prod => {
              const key = `${prod.idTpv}_${prod.PLU3 || "Simple"}`;
              if (!seenTpvUnit.has(key)) {
                seenTpvUnit.add(key);
                return true;
              }
              return false;
            });

            this.productosPorTpv = deDuplicatedVal.map(prod => ({
              idTpvServer: prod.idTpv,
              idCategory: prod.idCategory,
              tipoIva: Number(prod.vatType) || 0,
              price1: Number(prod.price1) || 0,
              price2: Number(prod.price2) || 0,
              price3: Number(prod.price3) || 0,
              price4: Number(prod.price4) || 0,
              namePrice1: prod.namePrice1 || "",
              namePrice2: prod.namePrice2 || "",
              namePrice3: prod.namePrice3 || "",
              namePrice4: prod.namePrice4 || "",
              selPrice1: prod.selPrice1 == "1",
              selPrice2: prod.selPrice2 == "1",
              selPrice3: prod.selPrice3 == "1",
              selPrice4: prod.selPrice4 == "1",
              color: prod.color || "amarillo",
              nombreProducto: prod.nombreProducto || prod.name || "",
              descripcion: prod.descripcion || prod.description || "",
              codigoBarras: prod.codigoBarras || prod.barCode || "",
              orden: prod.orden || prod.orderCode || 999,
              baja: prod.baja || false,
              descuento: prod.descuento || false,
              isMenu: prod.isMenu || false,
              isClosed: prod.isClosed || false,
              PLU1: prod.PLU1,
              PLU2: prod.PLU2,
              PLU3: prod.PLU3,
              PLU4: prod.PLU4
            }));

            this.localProductosMultiples = [];
            this.inSavingProgress = false;
            return;
          }

          // Caso 2: Tarifas 
          // !!!! NO SE USA ESTO, SE USA configTarifasByUdsMedida
          // Para ahorrarte 30 min de búsqueda y sufrimiento
          else if (primerProducto.PLU2 === "Tarifas") {
            // console.log(" > Caso 2: Tarifas - No deberia entrar aqui ni si quiera");
            this.producto = {
              ...this.producto,
              nombreProducto: primerProducto.nombreProducto || primerProducto.name || "",
              descripcion: primerProducto.descripcion || primerProducto.description || "",
              codigoBarras: primerProducto.codigoBarras || primerProducto.barCode || "",
              color: primerProducto.color || "amarillo",
              orden: primerProducto.orden || primerProducto.orderCode || 999,
              baja: primerProducto.baja || false,
              descuento: primerProducto.descuento || false,
              isMenu: primerProducto.isMenu || false,
              isClosed: primerProducto.isClosed || false,
            };
          }

          // Caso 3: Formatos
          else if (primerProducto.PLU2 === "Formatos") {
            // console.log(" > Caso 3: Formatos");
            this.localProductosMultiples.forEach((multiProducto, index) => {
              const unidad = multiProducto.unidad;
              const primerProductoFormato = newVal.find(p => p.PLU3 === unidad);
              if (primerProductoFormato) {
                this.$set(this.localProductosMultiples[index], 'producto', {
                  ...this.localProductosMultiples[index].producto,
                  nombreProducto: primerProductoFormato.nombreProducto || primerProductoFormato.name || "",
                  descripcion: primerProductoFormato.descripcion || primerProductoFormato.description || "",
                  codigoBarras: primerProductoFormato.codigoBarras || primerProductoFormato.barCode || "",
                  color: primerProductoFormato.color || "amarillo",
                  selPrice1: primerProductoFormato.selPrice1 == "1",
                  namePrice1: primerProductoFormato.namePrice1 || "",
                  selPrice2: primerProductoFormato.selPrice2 == "1",
                  namePrice2: primerProductoFormato.namePrice2 || "",
                  selPrice3: primerProductoFormato.selPrice3 == "1",
                  namePrice3: primerProductoFormato.namePrice3 || "",
                  selPrice4: primerProductoFormato.selPrice4 == "1",
                  namePrice4: primerProductoFormato.namePrice4 || "",
                  orden: primerProductoFormato.orden || primerProductoFormato.orderCode || 999,
                  baja: primerProductoFormato.baja || false,
                  descuento: primerProductoFormato.descuento || false,
                  isMenu: primerProductoFormato.isMenu || false,
                  isClosed: primerProductoFormato.isClosed || false,
                });
              }
            });

            // Actualizar this.producto para la pestaña activa
            const unidadActiva = this.localProductosMultiples && this.localProductosMultiples[this.indexProductoActivo]
              ? this.localProductosMultiples[this.indexProductoActivo].unidad
              : null;
            const primerProductoFormatoActual = unidadActiva
              ? newVal.find(p => p.PLU3 === unidadActiva)
              : null;
            if (primerProductoFormatoActual) {
              this.producto = {
                ...this.producto,
                nombreProducto: primerProductoFormatoActual.nombreProducto || primerProductoFormatoActual.name || "",
                descripcion: primerProductoFormatoActual.descripcion || primerProductoFormatoActual.description || "",
                codigoBarras: primerProductoFormatoActual.codigoBarras || primerProductoFormatoActual.barCode || "",
                color: primerProductoFormatoActual.color || "amarillo",
                selPrice1: primerProductoFormatoActual.selPrice1 == "1",
                namePrice1: primerProductoFormatoActual.namePrice1 || "",
                selPrice2: primerProductoFormatoActual.selPrice2 == "1",
                namePrice2: primerProductoFormatoActual.namePrice2 || "",
                selPrice3: primerProductoFormatoActual.selPrice3 == "1",
                namePrice3: primerProductoFormatoActual.namePrice3 || "",
                selPrice4: primerProductoFormatoActual.selPrice4 == "1",
                namePrice4: primerProductoFormatoActual.namePrice4 || "",
                orden: primerProductoFormatoActual.orden || primerProductoFormatoActual.orderCode || 999,
                baja: primerProductoFormatoActual.baja || false,
                descuento: primerProductoFormatoActual.descuento || false,
                isMenu: primerProductoFormatoActual.isMenu || false,
                isClosed: primerProductoFormatoActual.isClosed || false,
              };
            }

            this.actualizarCamposComunes();
          }

          // Caso 4: CON-SUPLEMENTO
          else if (primerProducto.PLU2 === "CON-SUPLEMENTO") {
            // console.log(" > Caso 4: CON-SUPLEMENTO");
            const conData = newVal.find(p => p.multiProductoIndex === 0);
            const suplementoData = newVal.find(p => p.multiProductoIndex === 1);

            this.localProductosMultiples = [
              {
                label: 'CON',
                producto: {
                  ...this.producto,
                  nombreProducto: conData.nombreProducto || conData.name || '',
                  descripcion: conData.descripcion || conData.description || '',
                  codigoBarras: conData.codigoBarras || conData.barCode || '',
                  color: conData.color || "amarillo",
                  namePrice1: '',
                  namePrice2: '',
                  namePrice3: '',
                  namePrice4: '',
                  selPrice1: false,
                  selPrice2: false,
                  selPrice3: false,
                  selPrice4: false,
                  price1: 0,
                  price2: 0,
                  price3: 0,
                  price4: 0,
                  orden: conData.orden || conData.orderCode || 999,
                  baja: conData.baja || false,
                  descuento: conData.descuento || false,
                  isMenu: conData.isMenu || false,
                  isClosed: conData.isClosed || false,
                  idCategory: conData.idCategory || null,
                  tipoIva: (conData.tipoIva !== undefined && conData.tipoIva !== null) ? Number(conData.tipoIva) : null,
                },
              },
              {
                label: 'SUPLEMENTO',
                producto: {
                  ...this.producto,
                  nombreProducto: suplementoData.nombreProducto || suplementoData.name || '',
                  descripcion: suplementoData.descripcion || suplementoData.description || '',
                  codigoBarras: suplementoData.codigoBarras || suplementoData.barCode || '',
                  color: suplementoData.color || "amarillo",
                  selPrice1: false,
                  namePrice1: suplementoData.namePrice1 || 'SUPLEMENTO',
                  namePrice2: '',
                  namePrice3: '',
                  namePrice4: '',
                  selPrice2: false,
                  selPrice3: false,
                  selPrice4: false,
                  price1: suplementoData.price1 || 0,
                  price2: 0,
                  price3: 0,
                  price4: 0,
                  orden: suplementoData.orden || suplementoData.orderCode || 999,
                  baja: suplementoData.baja || false,
                  descuento: suplementoData.descuento || false,
                  isMenu: suplementoData.isMenu || false,
                  isClosed: suplementoData.isClosed || false,
                  idCategory: suplementoData.idCategory || null,
                  tipoIva: (suplementoData.tipoIva !== undefined && suplementoData.tipoIva !== null) ? Number(suplementoData.tipoIva) : null,
                },
              },
            ];

            this.productosPorTpv = newVal.map(prod => ({
              ...prod,
              nombreProducto: prod.nombreProducto || prod.name || "",
              descripcion: prod.descripcion || prod.description || "",
              codigoBarras: prod.codigoBarras || prod.barCode || "",
              color: prod.color || "amarillo",
              price1: prod.price1 || 0,
              price2: prod.price2 || 0,
              price3: prod.price3 || 0,
              price4: prod.price4 || 0,
            }));

            this.producto = { ...this.localProductosMultiples[this.indexProductoActivo].producto };

            this.categoriasBloqueadas = true;
            this.tarifasBloqueadas = true;
            this.numTarifasActivas = this.indexProductoActivo === 0 ? 0 : 1;

            this.actualizarCamposComunes();
          }

          // Actualizar encabezados y categorías
          this.updateHeaders();
          this.getCategoryListBySelectedTpvServerList();
          this.checkProductosPorTpvRecuperados();
        } else {
          // Si no hay productos, inicializar
          if (!this.productsDataToFillForm || this.productsDataToFillForm.length === 0) {
            this.inicializarProductosPorTpv();
            this.actualizarCamposComunes();
          }
        }
      },
      immediate: true,
      deep: true,
    },

    indexProductoActivo(nuevo) {
      // console.log(" > Pestaña activa cambiada:", nuevo);
      // Actualiza this.producto con los datos del producto activo
      if (this.crearMultiplesProductosByUdsMedida && this.localProductosMultiples.length > 0) {

        const activeUnidad = this.localProductosMultiples[nuevo].unidad || "";
        const baseNombre = this.productoSeleccionado.productName || "";

        const activeProducto = this.localProductosMultiples[nuevo].producto;
        this.$set(this, 'producto', {
          nombreProducto: `${baseNombre} ${activeUnidad}`,
          descripcion: activeProducto.descripcion || "",
          codigoBarras: activeProducto.codigoBarras || "",
          color: activeProducto.color || "amarillo",
          selPrice1: activeProducto.selPrice1 || false,
          selPrice2: activeProducto.selPrice2 || false,
          selPrice3: activeProducto.selPrice3 || false,
          selPrice4: activeProducto.selPrice4 || false,
          namePrice1: activeProducto.namePrice1 || "",
          namePrice2: activeProducto.namePrice2 || "",
          namePrice3: activeProducto.namePrice3 || "",
          namePrice4: activeProducto.namePrice4 || "",
          orden: activeProducto.orden || 999,
          baja: activeProducto.baja || false,
          descuento: activeProducto.descuento || false,
          isMenu: activeProducto.isMenu || false,
          isClosed: activeProducto.isClosed || false,
        });

        // Actualizar los encabezados de las tarifas
        this.updateHeaders();

        // Sincronizar cambios a localProductosMultiples
        this.$nextTick(() => {
          this.actualizarCamposComunes();
        });
      }

      if (this.productoSeleccionado.MostrarEnListaCON && this.productoSeleccionado.MostrarEnListaSUPLEMENTO) {
        // Caso: Producto en listas CON y SUPLEMENTO
        const activeProducto = this.localProductosMultiples[nuevo].producto;
        this.producto = {
          ...this.producto,
          nombreProducto: activeProducto.nombreProducto || '',
          descripcion: activeProducto.descripcion || '',
          codigoBarras: activeProducto.codigoBarras || '',
          color: activeProducto.color || '',
          selPrice1: activeProducto.selPrice1 || false,
          selPrice2: activeProducto.selPrice2 || false,
          selPrice3: activeProducto.selPrice3 || false,
          selPrice4: activeProducto.selPrice4 || false,
          namePrice1: activeProducto.namePrice1 || '',
          namePrice2: activeProducto.namePrice2 || '',
          namePrice3: activeProducto.namePrice3 || '',
          namePrice4: activeProducto.namePrice4 || '',
          price1: activeProducto.price1 || 0,
          price2: activeProducto.price2 || 0,
          price3: activeProducto.price3 || 0,
          price4: activeProducto.price4 || 0,
          orden: activeProducto.orden || 999,
          baja: activeProducto.baja || false,
          descuento: activeProducto.descuento || false,
          isMenu: activeProducto.isMenu || false,
          isClosed: activeProducto.isClosed || false,
          idCategory: activeProducto.idCategory || null,
          tipoIva: (activeProducto.tipoIva !== undefined && activeProducto.tipoIva !== null) ? Number(activeProducto.tipoIva) : null,
        };
        // Configurar tarifas y categorías según el tab activo
        this.categoriasBloqueadas = true;
        this.tarifasBloqueadas = true;
        this.numTarifasActivas = nuevo === 0 ? 0 : 1; // 0 para CON, 1 para SUPLEMENTO

        // Actualizar los encabezados de las tarifas
        this.updateHeaders();

        // Sincronizar cambios a localProductosMultiples
        this.$nextTick(() => {
          this.actualizarCamposComunes();
        });
      }
    },

    // Añadimos watch para crearMultiplesProductosByUdsMedida y localProductosMultiples 
    // para reinicializar productosPorTpv cuando estas props cambien
    crearMultiplesProductosByUdsMedida: {
      handler(newVal) {
        if (newVal && this.localProductosMultiples.length > 0) {
          // console.log(" > Detectado cambio en crearMultiplesProductosByUdsMedida...");

          // Solo inicializar si no tenemos ya valores recuperados
          if (!this.productosPorTpvRecuperados || this.productosPorTpvRecuperados.length === 0) {
            // Produce un warn porque estamos modificando el valor de una prop de solo lectura, pero no se me ocurre otra solucion para que funcione el concatenar el nombre producto + la persistencia en el caso 3. 
            this.productosPorTpvRecuperados = ["hola"];
            this.inicializarProductosPorTpv();
          }
        } else if (newVal === false) {
          const seenTpv = new Set();
          this.productosPorTpv = this.productosPorTpv.filter(prod => {
            if (!seenTpv.has(prod.idTpvServer)) {
              seenTpv.add(prod.idTpvServer);
              return true;
            }
            return false;
          });
        }
      },
      immediate: true
    },

    nombreProductoInicial(newValue) {
      // Actualizar reactivamente producto.nombreProducto
      this.$set(this.producto, 'nombreProducto', newValue);
    },
  },
  methods: {
    evitarComasDecimales(event) {
      if (event.key === ",") {
        event.preventDefault();
      }
    },

    // Para seleccionar todo el texto de un input, en este caso de las celdas de Tarifas de la tabla. 
    // this.$nextTick() espera al próximo tick (micro-tarea) y entonces selecciona el contenido
    // select() es un método nativo de los <input> que selecciona todo el texto
    selectAll(event) {
      // Esperamos un tick para asegurarnos de que el input esté enfocado
      this.$nextTick(() => {
        event.target.select();
      });
    },

    // Método asegura que las actualizaciones de precios solo afecten al producto con el multiProductoIndex activo en el modo multi-producto, respetando la opción
    // replicarTarifas al actualizar solo los productos correspondientes.
    updateTarifaValue(tpv, priceKey, event) {
      // console.log(` > Actualizando ${priceKey} para idTpvServer: ${tpv.idTpvServer}, valor: ${value}`);
      // console.log(" > productosPorTpv después de actualizar tarifa:", JSON.parse(JSON.stringify(this.productosPorTpv)));

      const value = event || 0;

      if (this.producto.replicarTarifas) {
        this.productosPorTpv.forEach((producto, index) => {
          if ((!this.crearMultiplesProductosByUdsMedida &&
            !(this.productoSeleccionado.MostrarEnListaCON && this.productoSeleccionado.MostrarEnListaSUPLEMENTO)) ||
            producto.multiProductoIndex === this.indexProductoActivo) {
            this.$set(this.productosPorTpv, index, { ...producto, [priceKey]: value });
          }
        });
        // console.log(" > Productos actualizados:", this.productosPorTpv);
        // console.log(" > Productos actualizados:", JSON.parse(JSON.stringify(this.productosPorTpv)));

      } else {
        this.$set(tpv, priceKey, value);
        // console.log("estamos aqui actualizndo la tarifa");
        // console.log("event", event);
        // console.log("value", value);
        // console.log("priceKey", priceKey);

        const productoIndex = this.productosPorTpv.findIndex(
          prod => prod.idTpvServer === tpv.idTpvServer &&
            (
              (!this.crearMultiplesProductosByUdsMedida &&
                !(this.productoSeleccionado.MostrarEnListaCON && this.productoSeleccionado.MostrarEnListaSUPLEMENTO)) ||
              prod.multiProductoIndex === this.indexProductoActivo
            )
        );
        if (productoIndex !== -1) {
          this.$set(this.productosPorTpv, productoIndex, {
            ...this.productosPorTpv[productoIndex],
            [priceKey]: value
          });
        }
        // console.log(" > Productos actualizados:", this.productosPorTpv);
        // console.log(" > Productos actualizados:", JSON.parse(JSON.stringify(this.productosPorTpv)));
      }
    },

    actualizarNombreTarifa() {
      this.updateHeaders();
      this.actualizarCamposComunes();
    },

    // El método updateHeaders() actualiza los valores del array cuando se produce el input en los campos del form. Se usa this.$set() para actualizar los headers en tiempo real y
    // si el usuario borra el input, el encabezado vuelve al valor por defecto (“Tarifa 1”).
    updateHeaders() {
      this.$set(this.namePriceHeaders, 0, this.producto.namePrice1.trim() || "Tarifa 1");
      this.$set(this.namePriceHeaders, 1, this.producto.namePrice2.trim() || "Tarifa 2");
      this.$set(this.namePriceHeaders, 2, this.producto.namePrice3.trim() || "Tarifa 3");
      this.$set(this.namePriceHeaders, 3, this.producto.namePrice4.trim() || "Tarifa 4");
    },

    getCategoryListBySelectedTpvServerList() {
      // console.log(" > He llamado a getCategoryListBySelectedTpvServerList");
      if (this.listCategoriesByBusiness && this.listCategoriesByBusiness.length > 0) {
        this.categoryListBySelectedTpvServerList = this.listCategoriesByBusiness.map(business => ({
          ...business,
          idBusiness: business.idBusiness || business.id,
          tpvServer: business.tpvServer && typeof business.tpvServer === 'object' ? business.tpvServer.id : business.tpvServer,
          categories: business.categories.map(category => ({
            id: Number(category.id),
            name: category.name
          }))
        }));

        // Ahora, si tenemos productDataInfo, vamos a pre-seleccionar la categoría y grupo enlazado
        if (this.productDataInfo && this.productDataInfo.tpvs) {
          this.$nextTick(() => {
            for (const tpvId in this.productDataInfo.tpvs) {
              const tpvData = this.productDataInfo.tpvs[tpvId];
              if (tpvData.productos && tpvData.productos.length > 0) {
                // Obtengo los datos del producto para este TPV específico
                const productoData = JSON.parse(JSON.stringify(tpvData.productos[0].producto));
                const idCategory = productoData.idCategory;
                const grupoEnlazado = productoData.grupo_enlazado;
                const nombreProducto = productoData.name || productoData.nombreProducto || "sin-nombre";

                // Obtengo el producto para este TPV específico
                const productoTpv = this.getProductoForTpv(tpvId);

                // console.log(" > Procesando TPV:", tpvId);
                // console.log(" > Datos del producto para TPV:", productoTpv);
                // console.log(" > ID de categoría del producto:", idCategory);
                // console.log(" > Grupo enlazado del producto:", grupoEnlazado);

                if (productoTpv) {
                  // Asegurarse de que estamos trabajando con los datos correctos del TPV
                  if (idCategory) {
                    // console.log(` > Estableciendo categoría ${idCategory} para Producto '${nombreProducto}' en TPV ${tpvId}`);
                    this.$set(productoTpv, 'idCategory', Number(idCategory));
                  }

                  if (grupoEnlazado && grupoEnlazado != 0) {
                    // console.log(` > Estableciendo grupo enlazado ${grupoEnlazado} para Producto '${nombreProducto}' en TPV ${tpvId}`);
                    this.$set(productoTpv, 'grupo_enlazado', String(grupoEnlazado));
                  }
                } else {
                  console.warn(`No se encontró producto para TPV ${tpvId}`);
                }
              }
            }
          });
        }
        // console.log(" > productDataInfo:", this.productDataInfo);
      }

      // console.log(" > Categorías filtradas:", this.categoryListBySelectedTpvServerList);
    },

    // Este método devuelve la lista de categorías correspondientes a un TPV específico (idTpvServer) dentro de los TPVs seleccionados. 
    // 1.- Busca en categoryListBySelectedTpvServerList el objeto que tenga el mismo tpvServer que el id recibido como parámetro.
    // Si encuentra coincidencia, devuelve su lista de categorías.
    // Si no encuentra coincidencia, devuelve un array vacío [].
    getCategoriesForTPV(idTpvServer, isLinkedCategory = false) {

      let allCategories = [];
      const seenIds = new Set();
      const seenNames = new Set();

      const addCategory = (cat) => {
        const id = Number(cat.id);
        const name = cat.name ? String(cat.name).trim() : "";
        if (!id || !name) return;

        if (!seenIds.has(id) && !seenNames.has(name.toLowerCase())) {
          seenIds.add(id);
          seenNames.add(name.toLowerCase());
          allCategories.push({ id, name });
        }
      };

      if (this.categoryListBySelectedTpvServerList && this.categoryListBySelectedTpvServerList.length > 0) {
        this.categoryListBySelectedTpvServerList.forEach(item => {
          if (item.tpvServer == idTpvServer && item.categories && Array.isArray(item.categories)) {
            item.categories.forEach(addCategory);
          }
        });
      }

      if (allCategories.length === 0 && this.listCategoriesByBusiness && this.listCategoriesByBusiness.length > 0) {
        this.listCategoriesByBusiness.forEach(business => {
          const businessTpv = business.tpvServer && typeof business.tpvServer === 'object' ? business.tpvServer.id : business.tpvServer;
          if (businessTpv == idTpvServer && business.categories && Array.isArray(business.categories)) {
            business.categories.forEach(addCategory);
          }
        });
      }

      let categories = allCategories;

      if (!isLinkedCategory) {
        // Filtrar "CON" si MostrarEnListaCON es false
        if (this.productoSeleccionado && this.productoSeleccionado.MostrarEnListaCON === false) {
          categories = categories.filter(cat => cat.name !== 'CON' && cat.name !== 'con');
        }

        // Filtrar "SUPLEMENTO" si MostrarEnListaSUPLEMENTO es false
        if (this.productoSeleccionado && this.productoSeleccionado.MostrarEnListaSUPLEMENTO === false) {
          categories = categories.filter(cat => cat.name !== 'SUPLEMENTO' && cat.name !== 'suplemento');
        }
      }

      return categories;
    },

    // IVA que llega desde Business Central para el producto del paso 1.
    // Devuelve null si no viene o no es un número.
    getIvaBusinessCentral() {
      const bruto = this.productoSeleccionado
        ? this.productoSeleccionado.impuestoPorcentaje
        : null;

      if (bruto === null || bruto === undefined || bruto === "") return null;

      const n = Number(bruto);

      return isNaN(n) ? null : n;
    },

    // Devuelve la lista de IVAs seleccionables para un TPV concreto.
    // 1.- Toma iva1..iva5 del TPV, los normaliza a número y descarta los no válidos.
    // 2.- Si el TPV no los tiene configurados vienen los cinco a 0. Eso NO es
    //     "IVA 0", es "sin configurar", y antes colapsaba en una única opción a 0
    //     al deduplicar. En ese caso caemos a la lista estándar 4 / 10 / 21, la
    //     misma que usa ProductoFormCompleto y la que aplica getIvaByTpv en la API.
    // 3.- El IVA que llega de Business Central se añade siempre si no estaba, para
    //     que la preselección sea realmente seleccionable y el dato viaje al guardar.
    getIvaForTPV(idTpvServer) {
      const tpv = this.selectedTpvServerList.find(t => t.idTpvServer == idTpvServer);

      const valores = [];

      if (tpv) {
        [tpv.iva1, tpv.iva2, tpv.iva3, tpv.iva4, tpv.iva5].forEach(v => {
          if (v === null || v === undefined || v === "") return;

          const n = Number(v);

          if (!isNaN(n)) valores.push(n);
        });
      }

      // Las ranuras iva1..iva5 que no se usan quedan a 0. No son un "IVA 0", son
      // huecos vacíos, así que no deben aparecer como opción. Si el producto es
      // realmente exento, el 0 vuelve a entrar más abajo por la vía del IVA de BC.
      const configurados = valores.filter(v => v !== 0);
      const lista = configurados.length ? configurados : this.ivasPorDefecto.slice();

      const ivaBC = this.getIvaBusinessCentral();

      if (ivaBC !== null && lista.indexOf(ivaBC) === -1) {
        lista.push(ivaBC);
      }

      lista.sort((a, b) => a - b);

      const vistos = new Set();
      const unicos = [];

      lista.forEach(v => {
        if (!vistos.has(v)) {
          vistos.add(v);
          unicos.push({ id: unicos.length + 1, value: v, label: v + " %" });
        }
      });

      return unicos;
    },

    // Datos del producto que ya existe en un TPV concreto, dentro de productDataInfo.
    getProductoDataDeTpv(idTpvServer) {
      const tpvData = this.productDataInfo && this.productDataInfo.tpvs
        ? this.productDataInfo.tpvs[idTpvServer]
        : null;

      if (tpvData && tpvData.productos && tpvData.productos.length > 0) {
        return tpvData.productos[0].producto;
      }

      return null;
    },

    // Categoría enlazada tal como está guardada para ESE TPV: id como texto, o null si no tiene.
    // Es un id de `categories`, propio de cada TPV: nunca se reutiliza el de otro TPV
    // (así se generaron los productos de Pineda que apuntaban a categorías del 11847).
    grupoEnlazadoGuardado(productoData) {
      if (!productoData) return null;
      const valor = productoData.grupo_enlazado;
      if (valor === undefined || valor === null || valor === "" || String(valor) === "0") return null;
      return String(valor);
    },

    // Lista plana de los productos que ya existen en Numier para un TPV (productDataInfo.tpvs
    // es un objeto indexado por idTpv con `productos: [{ producto }]`; se admite también el
    // formato antiguo en array).
    productosExistentesDeTpv(idTpvServer) {
      const tpvs = this.productDataInfo && this.productDataInfo.tpvs ? this.productDataInfo.tpvs : null;
      if (!tpvs) return [];

      const tpvData = Array.isArray(tpvs)
        ? tpvs.find(t => t && String(t.idTpv) === String(idTpvServer))
        : (tpvs[String(idTpvServer)] || tpvs[idTpvServer]);
      if (!tpvData) return [];

      const lista = Array.isArray(tpvData.productos)
        ? tpvData.productos
        : (Array.isArray(tpvData.prods) ? tpvData.prods : []);

      return lista.map(pw => (pw && pw.producto ? pw.producto : pw)).filter(Boolean);
    },

    // Producto que YA existe en un TPV concreto para una unidad (PLU3). El mismo código BC
    // tiene precios y (puede que) categoría distintos en cada TPV, así que cada fila TPV × unidad debe
    // arrancar con los datos de SU TPV y no con los de la pestaña (que vienen de un solo TPV).
    getProductoExistenteDeTpvPorUnidad(idTpvServer, unidad) {
      const key = String(unidad || "").trim().toUpperCase();
      if (!key) return null;

      return this.productosExistentesDeTpv(idTpvServer).find(
        p => String(p.PLU3 || "").trim().toUpperCase() === key
      ) || null;
    },

    // Categoría que ya usa este producto BC en un TPV (cualquiera de sus formatos), o null.
    categoriaExistenteEnTpv(idTpvServer) {
      const conCategoria = this.productosExistentesDeTpv(idTpvServer).find(p => Number(p.idCategory) > 0);
      return conCategoria ? Number(conCategoria.idCategory) : null;
    },

    // Valores con los que el padre sembró la pestaña de una unidad, antes de que el usuario
    // tocara nada. Sirve para saber si un campo de la pestaña ha sido editado.
    semillaOriginalDeUnidad(multiIndex, unidad) {
      if (!Array.isArray(this.productosMultiples) || this.productosMultiples.length === 0) return null;

      const key = String(unidad || "").trim().toUpperCase();
      const porUnidad = this.productosMultiples.find(
        pm => pm && String(pm.unidad || "").trim().toUpperCase() === key
      );
      const pm = porUnidad || this.productosMultiples[multiIndex];

      return pm && pm.producto ? pm.producto : null;
    },

    // Valores iniciales de una fila TPV × unidad (Formatos).
    //  - Si la unidad ya existe en ese TPV y el usuario NO ha tocado el campo en la pestaña,
    //    se usa el valor del producto de ese TPV.
    //  - Si el usuario ha editado el campo en la pestaña, su valor se aplica a todos los TPV.
    //  - Si la unidad no existe en ese TPV, se usa la pestaña (con la categoría del propio TPV).
    valoresFilaTpv(tabProducto, semilla, existenteTpv, idTpvServer) {
      const tab = tabProducto || {};
      const num = v => {
        const n = v !== undefined && v !== null && v !== "" ? parseFloat(String(v).replace(',', '.')) : 0;
        return isNaN(n) ? 0 : n;
      };
      const bool = v => v === true || v === 1 || v === "1" || v === "true";
      const str = v => (v === undefined || v === null ? "" : String(v));

      const editado = (campo, cmp) => {
        if (!semilla || semilla[campo] === undefined) return false;
        return !cmp(tab[campo], semilla[campo]);
      };
      const mismoNum = (a, b) => num(a) === num(b);
      const mismoBool = (a, b) => bool(a) === bool(b);
      const mismoStr = (a, b) => str(a).trim() === str(b).trim();

      const elegir = (campo, cmp, valorTpv, valorTab) =>
        (existenteTpv && !editado(campo, cmp)) ? valorTpv : valorTab;

      const valores = {};
      for (let k = 1; k <= 4; k++) {
        valores[`price${k}`] = elegir(`price${k}`, mismoNum,
          existenteTpv ? num(existenteTpv[`price${k}`]) : 0, num(tab[`price${k}`]));
        valores[`selPrice${k}`] = elegir(`selPrice${k}`, mismoBool,
          existenteTpv ? bool(existenteTpv[`selPrice${k}`]) : false, bool(tab[`selPrice${k}`]));
        valores[`namePrice${k}`] = elegir(`namePrice${k}`, mismoStr,
          existenteTpv ? str(existenteTpv[`namePrice${k}`]) : "", str(tab[`namePrice${k}`]));
      }
      valores.codigoBarras = elegir("codigoBarras", mismoStr,
        existenteTpv ? str(existenteTpv.barCode) : "", str(tab.codigoBarras));
      valores.descripcion = elegir("descripcion", mismoStr,
        existenteTpv ? str(existenteTpv.description) : "", str(tab.descripcion));
      valores.color = elegir("color", mismoStr,
        existenteTpv ? (str(existenteTpv.color) || str(tab.color)) : "", str(tab.color));

      // Categoría: las categorías son por TPV, así que una categoría de la pestaña solo vale
      // si pertenece a este TPV. Orden: la del producto existente, la que ya use este código BC
      // en el TPV, la de la pestaña si es de este TPV, y si no null (el usuario la elige).
      const catTab = (tab.idCategory !== undefined && tab.idCategory !== null)
        ? Number(tab.idCategory)
        : ((tab.idCategoria !== undefined && tab.idCategoria !== null) ? Number(tab.idCategoria) : 0);
      const catTabEsDeEsteTpv = catTab > 0 &&
        this.getCategoriesForTPV(idTpvServer).some(c => Number(c.id) === catTab);

      if (existenteTpv && Number(existenteTpv.idCategory) > 0) {
        valores.idCategory = Number(existenteTpv.idCategory);
      } else {
        const catTpv = this.categoriaExistenteEnTpv(idTpvServer);
        valores.idCategory = catTpv !== null ? catTpv : (catTabEsDeEsteTpv ? catTab : null);
      }

      return valores;
    },

    // IVA ya guardado de un producto. Respeta el 0 como valor válido (hay productos
    // exentos) y solo cae al valor actual de la fila cuando no hay dato ninguno.
    ivaGuardado(productoData, ivaActual) {
      if (productoData && productoData.vatType !== null && productoData.vatType !== undefined && productoData.vatType !== "") {
        const n = Number(productoData.vatType);

        if (!isNaN(n)) return n;
      }

      return (ivaActual !== null && ivaActual !== undefined) ? ivaActual : null;
    },

    // IVA preseleccionado para un TPV: el que manda Business Central si está entre
    // las opciones y, si no, el 10 por defecto. Solo devuelve null si no hay ninguna
    // opción, cosa que ya no debería pasar.
    ivaPorDefectoParaTpv(idTpvServer) {
      const opciones = this.getIvaForTPV(idTpvServer).map(i => Number(i.value));

      if (!opciones.length) return null;

      const ivaBC = this.getIvaBusinessCentral();

      if (ivaBC !== null && opciones.indexOf(ivaBC) !== -1) return ivaBC;

      if (opciones.indexOf(this.ivaPorDefectoSinDato) !== -1) return this.ivaPorDefectoSinDato;

      return opciones[0];
    },

    // Crea un array productosPorTpv con un objeto de producto para cada TPV seleccionado.
    // 1.- Recorre selectedTpvServerList y para cada TPV, genera un objeto con: idTpvServer, idBusiness, idCategory, tipoIva, price1 - price4.
    // 2.- Guarda esta lista en productosPorTpv.
    // Condición para múltiples productos: Si crearMultiplesProductosByUdsMedida es true y localProductosMultiples tiene elementos, iteramos sobre selectedTpvServerList y localProductosMultiples
    // para crear una combinación de productos (TPV × unidad de medida).
    inicializarProductosPorTpv() {
      console.log("inicializarProductosPorTpv");
      this.productosPorTpv = [];

      // Determinar el caso
      const isCase1 = !this.productoSeleccionado.udMedida || this.productoSeleccionado.udMedida.length <= 1;
      const isCase2 = !this.crearMultiplesProductosByUdsMedida &&
        this.productoSeleccionado.udMedida &&
        this.productoSeleccionado.udMedida.length > 1;
      const isCase3 = this.crearMultiplesProductosByUdsMedida &&
        this.productoSeleccionado.udMedida &&
        this.productoSeleccionado.udMedida.length > 1 &&
        (!this.productoSeleccionado.changeFormatToRates || this.productoSeleccionado.changeFormatToRates == 0);
      const isCase4 = this.crearMultiplesProductosByUdsMedida &&
        this.productoSeleccionado.udMedida &&
        this.productoSeleccionado.udMedida.length > 1 &&
        this.productoSeleccionado.changeFormatToRates;
      const isCaseCONySUPLEMENTO = this.productoSeleccionado &&
        this.productoSeleccionado.MostrarEnListaCON &&
        this.productoSeleccionado.MostrarEnListaSUPLEMENTO;

      // Valor de PLU2 según el caso
      let plu2Value = isCase1 ? "Simple" : isCase2 ? "Tarifas" : isCase3 ? "Formatos" : isCase4 ? "Formatos" : "Simple";
      if (isCaseCONySUPLEMENTO) {
        plu2Value = "CON-SUPLEMENTO";
      }

      // Si es Caso CON-SUPLEMENTO y hay localProductosMultiples, generamos productos por TPV y tab (CON y SUPLEMENTO)
      if (isCaseCONySUPLEMENTO && this.localProductosMultiples.length > 1) {
        // console.log("HA-1");
        // console.log(" > valores de this.categoryListBySelectedTpvServerList", this.categoryListBySelectedTpvServerList);
        // console.log(" > valores de this.localProductosMultiples", this.localProductosMultiples);

        // this.selectedTpvServerList.forEach(tpv => {
        //   this.localProductosMultiples.forEach((multiProducto, multiIndex) => {
        //     // Obtén la lista de IVAs para este TPV
        //     const ivas = this.getIvaForTPV(tpv.idTpvServer).map(i => parseInt(i.value));
        //     // El IVA del producto seleccionado (step 1)
        //     const ivaStep1 = parseInt(this.productoSeleccionado.impuestoPorcentaje);
        //     // Si el IVA del step 1 está en la lista de IVAs del TPV, lo ponemos por defecto
        //     const tipoIvaPorDefecto = ivas.includes(ivaStep1) ? ivaStep1 : null;

        //     // Determinar categoría según el tab (CON o SUPLEMENTO)
        //     const categoryName = multiIndex === 0 ? 'CON' : 'SUPLEMENTO';
        //     const tpvData = this.categoryListBySelectedTpvServerList.find(t => t.tpvServer === String(tpv.idTpvServer));
        //     const category = tpvData && tpvData.categories ? tpvData.categories.find(c => c.name === categoryName) : null;

        //     this.productosPorTpv.push({
        //       nombreProducto: multiProducto.producto.nombreProducto || "",
        //       descripcion: multiProducto.producto.descripcion || "",
        //       idTpvServer: tpv.idTpvServer,
        //       idBusiness: tpv.idBusiness || null,
        //       idCategory: category ? category.id : null,
        //       tipoIva: (tipoIvaPorDefecto !== undefined && tipoIvaPorDefecto !== null) ? Number(tipoIvaPorDefecto) : null,
        //       codigoBarras: multiProducto.producto.codigoBarras || "",
        //       color: multiProducto.producto.color || "",
        //       price1: multiProducto.producto.price1 || 0,
        //       price2: multiProducto.producto.price2 || 0,
        //       price3: multiProducto.producto.price3 || 0,
        //       price4: multiProducto.producto.price4 || 0,
        //       namePrice1: multiProducto.producto.namePrice1 || "",
        //       namePrice2: multiProducto.producto.namePrice2 || "",
        //       namePrice3: multiProducto.producto.namePrice3 || "",
        //       namePrice4: multiProducto.producto.namePrice4 || "",
        //       selPrice1: multiProducto.producto.selPrice1 || false,
        //       selPrice2: multiProducto.producto.selPrice2 || false,
        //       selPrice3: multiProducto.producto.selPrice3 || false,
        //       selPrice4: multiProducto.producto.selPrice4 || false,
        //       orden: multiProducto.producto.orden || 999,
        //       PLU1: this.productoSeleccionado.idProdBusinessCentral || "",
        //       PLU2: plu2Value, // "CON-SUPLEMENTO"
        //       PLU3: multiIndex === 0 ? "CON" : "SUPLEMENTO",
        //       PLU4: "",
        //       copiaImpresionKDSPDA: "Ninguna seleccionada",
        //       copiaImpresionKDSTPV: "Ninguna seleccionada",
        //       copiaImpresionPlano1: "Ninguna seleccionada",
        //       copiaImpresionPlano2: "Ninguna seleccionada",
        //       copiaImpresionPlano3: "Ninguna seleccionada",
        //       copiaImpresionPlano4: "Ninguna seleccionada",
        //       copiaImpresionPlano5: "Ninguna seleccionada",
        //       copiaImpresionPlano6: "Ninguna seleccionada",
        //       copiaImpresionPlano7: "Ninguna seleccionada",
        //       copiaImpresionPlano8: "Ninguna seleccionada",
        //       copiaImpresionPlanoKDS1: "Ninguna seleccionada",
        //       copiaImpresionPlanoKDS2: "Ninguna seleccionada",
        //       copiaImpresionPlanoKDS3: "Ninguna seleccionada",
        //       copiaImpresionPlanoKDS4: "Ninguna seleccionada",
        //       copiaImpresionPlanoKDS5: "Ninguna seleccionada",
        //       copiaImpresionPlanoKDS6: "Ninguna seleccionada",
        //       copiaImpresionPlanoKDS7: "Ninguna seleccionada",
        //       copiaImpresionPlanoKDS8: "Ninguna seleccionada",
        //       id: 0,
        //       idCuenta: "0",
        //       idCuenta2: "0",
        //       idCuenta3: "0",
        //       importe: false,
        //       impresionKDSPDA: "Ninguna seleccionada",
        //       impresionKDSTPV: "Ninguna seleccionada",
        //       impresionPlano1: "Ninguna seleccionada",
        //       impresionPlano2: "Ninguna seleccionada",
        //       impresionPlano3: "Ninguna seleccionada",
        //       impresionPlano4: "Ninguna seleccionada",
        //       impresionPlano5: "Ninguna seleccionada",
        //       impresionPlano6: "Ninguna seleccionada",
        //       impresionPlano7: "Ninguna seleccionada",
        //       impresionPlano8: "Ninguna seleccionada",
        //       impresionPlanoKDS1: "Ninguna seleccionada",
        //       impresionPlanoKDS2: "Ninguna seleccionada",
        //       impresionPlanoKDS3: "Ninguna seleccionada",
        //       impresionPlanoKDS4: "Ninguna seleccionada",
        //       impresionPlanoKDS5: "Ninguna seleccionada",
        //       impresionPlanoKDS6: "Ninguna seleccionada",
        //       impresionPlanoKDS7: "Ninguna seleccionada",
        //       impresionPlanoKDS8: "Ninguna seleccionada",
        //       mostrarPC: true,
        //       mostrarPDA: true,
        //       noImprimir: false,
        //       numOpcionales: 0,
        //       numPlato: 0,
        //       opcion1: "",
        //       opcion2: "",
        //       opcion3: "",
        //       opcion4: "",
        //       opcion5: "",
        //       peso: false,
        //       porcentajeContable: 0,
        //       porcentajeContable2: 0,
        //       porcentajeContable3: 0,
        //       precio: false,
        //       precioCoste: 0,
        //       precioCoste2: 0,
        //       precioCoste3: 0,
        //       precioCoste4: 0,
        //       precioCosteSinIVA: 0,
        //       precioCosteSinIVA2: 0,
        //       precioCosteSinIVA3: 0,
        //       precioCosteSinIVA4: 0,
        //       printerName: "Ninguna seleccionada",
        //       printerName2: "Ninguna seleccionada",
        //       printerPDAName: "Ninguna seleccionada",
        //       printerPDAName2: "Ninguna seleccionada",
        //       promocionable: false,
        //       seleccionarIngredientes: false,
        //       subproductos: [],
        //       xname: "",
        //       baja: false,
        //       descuento: false,
        //       isMenu: false,
        //       isClosed: false,
        //       multiProductoIndex: multiIndex // Para rastrear qué tab corresponde
        //     });
        //   });
        // });

        const newProductosPorTpv = [];

        this.categoryListBySelectedTpvServerList.forEach(tpvData => {
          if (tpvData && tpvData.categories) {
            // Producto CON
            const categoryCON = tpvData.categories.find(c => c.name === 'CON');
            const productoCON = {
              ...this.producto,
              idTpvServer: tpvData.tpvServer,
              multiProductoIndex: 0,
              idCategory: categoryCON ? categoryCON.id : null,
              tipoIva: (tpvData.tipoIva !== undefined && tpvData.tipoIva !== null) ? Number(tpvData.tipoIva) : null,
              namePrice1: '',
              selPrice1: false,
              price1: 0,
              namePrice2: '',
              selPrice2: false,
              price2: 0,
              namePrice3: '',
              selPrice3: false,
              price3: 0,
              namePrice4: '',
              selPrice4: false,
              price4: 0,
              PLU2: 'CON-SUPLEMENTO',
              PLU3: 'CON'
            };

            // Producto SUPLEMENTO
            const categorySUP = tpvData.categories.find(c => c.name === 'SUPLEMENTO');
            const productoSUP = {
              ...this.producto,
              idTpvServer: tpvData.tpvServer,
              multiProductoIndex: 1,
              idCategory: categorySUP ? categorySUP.id : null,
              tipoIva: (tpvData.tipoIva !== undefined && tpvData.tipoIva !== null) ? Number(tpvData.tipoIva) : null,
              namePrice1: 'SUPLEMENTO',
              selPrice1: false,
              price1: 0,
              namePrice2: '',
              selPrice2: false,
              price2: 0,
              namePrice3: '',
              selPrice3: false,
              price3: 0,
              namePrice4: '',
              selPrice4: false,
              price4: 0,
              PLU2: 'CON-SUPLEMENTO',
              PLU3: 'SUPLEMENTO'
            };

            newProductosPorTpv.push(productoCON, productoSUP);
          }
        });

        this.productosPorTpv = newProductosPorTpv;
      }

      // Si es Caso 3 y hay localProductosMultiples, generamos productos por TPV y unidad de medida
      if (isCase3 && this.localProductosMultiples.length > 1) {
        console.log("HA-2");
        // console.log(this.localProductosMultiples);

        this.selectedTpvServerList.forEach(tpv => {
          this.localProductosMultiples.forEach((multiProducto, multiIndex) => {
            // IVA de Business Central si está disponible, y si no el 10 por defecto.
            const tipoIvaPorDefecto = this.ivaPorDefectoParaTpv(tpv.idTpvServer);

            console.log("el multiproducto es", multiProducto);
            console.log("el tpv es", tpv);

            // console.log("[PF-Basico][initPPT][Case3] Fuente precios multiProducto (antes de push)", {
            //   ud: multiProducto.unidad,
            //   tpv: tpv.idTpvServer,
            //   fromLocal: { p1: multiProducto.producto.price1, p2: multiProducto.producto.price2, p3: multiProducto.producto.price3, p4: multiProducto.producto.price4 }
            // });

            // Precalcular el ID antes de hacer push
            const plu3Formato = multiProducto.unidad || "";
            const calculatedId = this.$parent.setIdProd2(
              this.$parent.productoSeleccionado,
              tpv.idTpvServer,
              plu3Formato
            );

            console.log("calculatedId", calculatedId);

            // Fila TPV × unidad: si la unidad ya existe en ESTE TPV, arranca con los precios,
            // categoría y código de barras de ese TPV (no con los de la pestaña, que vienen de
            // un solo TPV). Lo que el usuario haya editado en la pestaña se respeta para todos.
            const existenteTpv = this.getProductoExistenteDeTpvPorUnidad(tpv.idTpvServer, plu3Formato);
            const semilla = this.semillaOriginalDeUnidad(multiIndex, multiProducto.unidad);
            const fila = this.valoresFilaTpv(multiProducto.producto, semilla, existenteTpv, tpv.idTpvServer);

            this.productosPorTpv.push({
              nombreProducto: multiProducto.producto.nombreProducto || "", // Ej: "Coca-cola 33ML"
              descripcion: fila.descripcion,
              idTpvServer: tpv.idTpvServer,
              idBusiness: tpv.idBusiness || null,
              idCategory: fila.idCategory,
              tipoIva: (tipoIvaPorDefecto !== undefined && tipoIvaPorDefecto !== null) ? Number(tipoIvaPorDefecto) : null,
              codigoBarras: fila.codigoBarras,
              color: fila.color,
              price1: fila.price1,
              price2: fila.price2,
              price3: fila.price3,
              price4: fila.price4,
              namePrice1: fila.namePrice1,
              namePrice2: fila.namePrice2,
              namePrice3: fila.namePrice3,
              namePrice4: fila.namePrice4,
              selPrice1: fila.selPrice1,
              selPrice2: fila.selPrice2,
              selPrice3: fila.selPrice3,
              selPrice4: fila.selPrice4,
              orden: multiProducto.producto.orden || 999,
              PLU1: this.productoSeleccionado.idProdBusinessCentral || "",
              PLU2: plu2Value, // "Formatos"
              PLU3: plu3Formato, // Ej: "BOT", "LICOPA50", "UNID"
              PLU4: "",
              codUdMedida: plu3Formato,
              copiaImpresionKDSPDA: "Ninguna seleccionada",
              copiaImpresionKDSTPV: "Ninguna seleccionada",
              copiaImpresionPlano1: "Ninguna seleccionada",
              copiaImpresionPlano2: "Ninguna seleccionada",
              copiaImpresionPlano3: "Ninguna seleccionada",
              copiaImpresionPlano4: "Ninguna seleccionada",
              copiaImpresionPlano5: "Ninguna seleccionada",
              copiaImpresionPlano6: "Ninguna seleccionada",
              copiaImpresionPlano7: "Ninguna seleccionada",
              copiaImpresionPlano8: "Ninguna seleccionada",
              copiaImpresionPlanoKDS1: "Ninguna seleccionada",
              copiaImpresionPlanoKDS2: "Ninguna seleccionada",
              copiaImpresionPlanoKDS3: "Ninguna seleccionada",
              copiaImpresionPlanoKDS4: "Ninguna seleccionada",
              copiaImpresionPlanoKDS5: "Ninguna seleccionada",
              copiaImpresionPlanoKDS6: "Ninguna seleccionada",
              copiaImpresionPlanoKDS7: "Ninguna seleccionada",
              copiaImpresionPlanoKDS8: "Ninguna seleccionada",
              id: calculatedId,
              idCuenta: "0",
              idCuenta2: "0",
              idCuenta3: "0",
              importe: false,
              impresionKDSPDA: "Ninguna seleccionada",
              impresionKDSTPV: "Ninguna seleccionada",
              impresionPlano1: "Ninguna seleccionada",
              impresionPlano2: "Ninguna seleccionada",
              impresionPlano3: "Ninguna seleccionada",
              impresionPlano4: "Ninguna seleccionada",
              impresionPlano5: "Ninguna seleccionada",
              impresionPlano6: "Ninguna seleccionada",
              impresionPlano7: "Ninguna seleccionada",
              impresionPlano8: "Ninguna seleccionada",
              impresionPlanoKDS1: "Ninguna seleccionada",
              impresionPlanoKDS2: "Ninguna seleccionada",
              impresionPlanoKDS3: "Ninguna seleccionada",
              impresionPlanoKDS4: "Ninguna seleccionada",
              impresionPlanoKDS5: "Ninguna seleccionada",
              impresionPlanoKDS6: "Ninguna seleccionada",
              impresionPlanoKDS7: "Ninguna seleccionada",
              impresionPlanoKDS8: "Ninguna seleccionada",
              mostrarPC: true,
              mostrarPDA: true,
              noImprimir: false,
              numOpcionales: 0,
              numPlato: 0,
              opcion1: "",
              opcion2: "",
              opcion3: "",
              opcion4: "",
              opcion5: "",
              peso: false,
              porcentajeContable: 0,
              porcentajeContable2: 0,
              porcentajeContable3: 0,
              precio: false,
              precioCoste: 0,
              precioCoste2: 0,
              precioCoste3: 0,
              precioCoste4: 0,
              precioCosteSinIVA: 0,
              precioCosteSinIVA2: 0,
              precioCosteSinIVA3: 0,
              precioCosteSinIVA4: 0,
              printerName: "Ninguna seleccionada",
              printerName2: "Ninguna seleccionada",
              printerPDAName: "Ninguna seleccionada",
              printerPDAName2: "Ninguna seleccionada",
              promocionable: false,
              seleccionarIngredientes: false,
              subproductos: [],
              xname: "",
              baja: multiProducto.producto.baja || false,
              descuento: false,
              isMenu: false,
              isClosed: false,
              multiProductoIndex: multiIndex // Para rastrear qué unidad de medida corresponde
            });
          });
        });
      } else if (isCase4 && this.localProductosMultiples.length > 1) {
        console.log("HA-4");

        this.selectedTpvServerList.forEach(tpv => {
          this.localProductosMultiples.forEach((multiProducto, multiIndex) => {
            // console.log("multiProducto", multiProducto);

            // IVA de Business Central si está disponible, y si no el 10 por defecto.
            const tipoIvaPorDefecto = this.ivaPorDefectoParaTpv(tpv.idTpvServer);

            // console.log("[PF-Basico][initPPT][Case3] Fuente precios multiProducto (antes de push)", {
            //   ud: multiProducto.unidad,
            //   tpv: tpv.idTpvServer,
            //   fromLocal: { p1: multiProducto.producto.price1, p2: multiProducto.producto.price2, p3: multiProducto.producto.price3, p4: multiProducto.producto.price4 }
            // });

            // Paso de Tarifas a Formatos: las unidades son nuevas en el TPV (el tarifado tiene
            // PLU3 vacío), así que normalmente no hay producto existente por unidad. Se usa el
            // mismo criterio que en Formatos para que la categoría sea siempre del propio TPV.
            const existenteTpv = this.getProductoExistenteDeTpvPorUnidad(tpv.idTpvServer, multiProducto.unidad);
            const semilla = this.semillaOriginalDeUnidad(multiIndex, multiProducto.unidad);
            const fila = this.valoresFilaTpv(multiProducto.producto, semilla, existenteTpv, tpv.idTpvServer);

            this.productosPorTpv.push({
              nombreProducto: multiProducto.producto.nombreProducto || "", // Ej: "Coca-cola 33ML"
              descripcion: fila.descripcion,
              idTpvServer: tpv.idTpvServer,
              idBusiness: tpv.idBusiness || null,
              idCategory: fila.idCategory !== null ? fila.idCategory : 0,
              tipoIva: (tipoIvaPorDefecto !== undefined && tipoIvaPorDefecto !== null) ? Number(tipoIvaPorDefecto) : null,
              codigoBarras: fila.codigoBarras,
              color: fila.color,
              price1: fila.price1,
              price2: fila.price2,
              price3: fila.price3,
              price4: fila.price4,
              namePrice1: fila.namePrice1,
              namePrice2: fila.namePrice2,
              namePrice3: fila.namePrice3,
              namePrice4: fila.namePrice4,
              selPrice1: fila.selPrice1,
              selPrice2: fila.selPrice2,
              selPrice3: fila.selPrice3,
              selPrice4: fila.selPrice4,
              orden: multiProducto.producto.orden || 999,
              PLU1: this.productoSeleccionado.idProdBusinessCentral || "",
              PLU2: plu2Value, // "Formatos"
              PLU3: multiProducto.unidad || "", // Ej: "33ML", "Botella", "1L"
              PLU4: "",
              copiaImpresionKDSPDA: "Ninguna seleccionada",
              copiaImpresionKDSTPV: "Ninguna seleccionada",
              copiaImpresionPlano1: "Ninguna seleccionada",
              copiaImpresionPlano2: "Ninguna seleccionada",
              copiaImpresionPlano3: "Ninguna seleccionada",
              copiaImpresionPlano4: "Ninguna seleccionada",
              copiaImpresionPlano5: "Ninguna seleccionada",
              copiaImpresionPlano6: "Ninguna seleccionada",
              copiaImpresionPlano7: "Ninguna seleccionada",
              copiaImpresionPlano8: "Ninguna seleccionada",
              copiaImpresionPlanoKDS1: "Ninguna seleccionada",
              copiaImpresionPlanoKDS2: "Ninguna seleccionada",
              copiaImpresionPlanoKDS3: "Ninguna seleccionada",
              copiaImpresionPlanoKDS4: "Ninguna seleccionada",
              copiaImpresionPlanoKDS5: "Ninguna seleccionada",
              copiaImpresionPlanoKDS6: "Ninguna seleccionada",
              copiaImpresionPlanoKDS7: "Ninguna seleccionada",
              copiaImpresionPlanoKDS8: "Ninguna seleccionada",
              id: 0,
              idCuenta: "0",
              idCuenta2: "0",
              idCuenta3: "0",
              importe: false,
              impresionKDSPDA: "Ninguna seleccionada",
              impresionKDSTPV: "Ninguna seleccionada",
              impresionPlano1: "Ninguna seleccionada",
              impresionPlano2: "Ninguna seleccionada",
              impresionPlano3: "Ninguna seleccionada",
              impresionPlano4: "Ninguna seleccionada",
              impresionPlano5: "Ninguna seleccionada",
              impresionPlano6: "Ninguna seleccionada",
              impresionPlano7: "Ninguna seleccionada",
              impresionPlano8: "Ninguna seleccionada",
              impresionPlanoKDS1: "Ninguna seleccionada",
              impresionPlanoKDS2: "Ninguna seleccionada",
              impresionPlanoKDS3: "Ninguna seleccionada",
              impresionPlanoKDS4: "Ninguna seleccionada",
              impresionPlanoKDS5: "Ninguna seleccionada",
              impresionPlanoKDS6: "Ninguna seleccionada",
              impresionPlanoKDS7: "Ninguna seleccionada",
              impresionPlanoKDS8: "Ninguna seleccionada",
              mostrarPC: true,
              mostrarPDA: true,
              noImprimir: false,
              numOpcionales: 0,
              numPlato: 0,
              opcion1: "",
              opcion2: "",
              opcion3: "",
              opcion4: "",
              opcion5: "",
              peso: false,
              porcentajeContable: 0,
              porcentajeContable2: 0,
              porcentajeContable3: 0,
              precio: false,
              precioCoste: 0,
              precioCoste2: 0,
              precioCoste3: 0,
              precioCoste4: 0,
              precioCosteSinIVA: 0,
              precioCosteSinIVA2: 0,
              precioCosteSinIVA3: 0,
              precioCosteSinIVA4: 0,
              printerName: "Ninguna seleccionada",
              printerName2: "Ninguna seleccionada",
              printerPDAName: "Ninguna seleccionada",
              printerPDAName2: "Ninguna seleccionada",
              promocionable: false,
              seleccionarIngredientes: false,
              subproductos: [],
              xname: "",
              baja: multiProducto.producto.baja || false,
              descuento: false,
              isMenu: false,
              isClosed: false,
              multiProductoIndex: multiIndex // Para rastrear qué unidad de medida corresponde
            });
          });
        });
      } else {
        console.log("HA-3");

        // Caso 1 o Caso 2: un producto por TPV
        this.productosPorTpv = this.selectedTpvServerList.map(tpv => {
          // IVA de Business Central si está disponible, y si no el 10 por defecto.
          const tipoIvaPorDefecto = this.ivaPorDefectoParaTpv(tpv.idTpvServer);

          return {
            nombreProducto: this.productoSeleccionado.productName || "",
            descripcion: "",
            idTpvServer: tpv.idTpvServer,
            idBusiness: tpv.idBusiness || null,
            idCategory: null,
            tipoIva: (tipoIvaPorDefecto !== undefined && tipoIvaPorDefecto !== null) ? Number(tipoIvaPorDefecto) : null,
            codigoBarras: "",
            color: "",
            price1: 0,
            price2: 0,
            price3: 0,
            price4: 0,
            namePrice1: "",
            namePrice2: "",
            namePrice3: "",
            namePrice4: "",
            orden: 999,
            PLU1: this.productoSeleccionado.idProdBusinessCentral || "",
            PLU2: plu2Value, // "Simple" o "Tarifas"
            PLU3: this.productoSeleccionado.udMedida[0],
            PLU4: "",
            copiaImpresionKDSPDA: "Ninguna seleccionada",
            copiaImpresionKDSTPV: "Ninguna seleccionada",
            copiaImpresionPlano1: "Ninguna seleccionada",
            copiaImpresionPlano2: "Ninguna seleccionada",
            copiaImpresionPlano3: "Ninguna seleccionada",
            copiaImpresionPlano4: "Ninguna seleccionada",
            copiaImpresionPlano5: "Ninguna seleccionada",
            copiaImpresionPlano6: "Ninguna seleccionada",
            copiaImpresionPlano7: "Ninguna seleccionada",
            copiaImpresionPlano8: "Ninguna seleccionada",
            copiaImpresionPlanoKDS1: "Ninguna seleccionada",
            copiaImpresionPlanoKDS2: "Ninguna seleccionada",
            copiaImpresionPlanoKDS3: "Ninguna seleccionada",
            copiaImpresionPlanoKDS4: "Ninguna seleccionada",
            copiaImpresionPlanoKDS5: "Ninguna seleccionada",
            copiaImpresionPlanoKDS6: "Ninguna seleccionada",
            copiaImpresionPlanoKDS7: "Ninguna seleccionada",
            copiaImpresionPlanoKDS8: "Ninguna seleccionada",
            id: 0,
            idCuenta: "0",
            idCuenta2: "0",
            idCuenta3: "0",
            importe: false,
            impresionKDSPDA: "Ninguna seleccionada",
            impresionKDSTPV: "Ninguna seleccionada",
            impresionPlano1: "Ninguna seleccionada",
            impresionPlano2: "Ninguna seleccionada",
            impresionPlano3: "Ninguna seleccionada",
            impresionPlano4: "Ninguna seleccionada",
            impresionPlano5: "Ninguna seleccionada",
            impresionPlano6: "Ninguna seleccionada",
            impresionPlano7: "Ninguna seleccionada",
            impresionPlano8: "Ninguna seleccionada",
            impresionPlanoKDS1: "Ninguna seleccionada",
            impresionPlanoKDS2: "Ninguna seleccionada",
            impresionPlanoKDS3: "Ninguna seleccionada",
            impresionPlanoKDS4: "Ninguna seleccionada",
            impresionPlanoKDS5: "Ninguna seleccionada",
            impresionPlanoKDS6: "Ninguna seleccionada",
            impresionPlanoKDS7: "Ninguna seleccionada",
            impresionPlanoKDS8: "Ninguna seleccionada",
            mostrarPC: true,
            mostrarPDA: true,
            noImprimir: false,
            numOpcionales: 0,
            numPlato: 0,
            opcion1: "",
            opcion2: "",
            opcion3: "",
            opcion4: "",
            opcion5: "",
            peso: false,
            porcentajeContable: 0,
            porcentajeContable2: 0,
            porcentajeContable3: 0,
            precio: false,
            precioCoste: 0,
            precioCoste2: 0,
            precioCoste3: 0,
            precioCoste4: 0,
            precioCosteSinIVA: 0,
            precioCosteSinIVA2: 0,
            precioCosteSinIVA3: 0,
            precioCosteSinIVA4: 0,
            printerName: "Ninguna seleccionada",
            printerName2: "Ninguna seleccionada",
            printerPDAName: "Ninguna seleccionada",
            printerPDAName2: "Ninguna seleccionada",
            promocionable: false,
            seleccionarIngredientes: false,
            subproductos: [],
            xname: "",
            baja: false,
            descuento: false,
            isMenu: false,
            isClosed: false,
          };
        });
      }
      console.log(" > Productos inicializados:", this.productosPorTpv);
    },

    // Actualiza de manera reactiva todos los productos dentro de productosPorTpv, asegurando que los campos comunes sean iguales en todas las variantes del producto.
    // 1.- Recorre productosPorTpv con forEach, accediendo a cada producto por su índice.
    // 2.- Usa this.$set() para actualizar el producto en la lista de forma reactiva.
    // 3.- Copia los valores comunes desde this.producto a cada elemento en productosPorTpv.
    // Cuando crearMultiplesProductosByUdsMedida es true, actualizamos el array localProductosMultiples para el producto de la pestaña activa y solo actualizamos las entradas de productosPorTpv donde
    // multiProductoIndex coincide con indexProductoActivo.
    // Esto asegura que los campos comunes (por ejemplo, descripcion: "refresco de cola") solo se apliquen a los productos con la unidad de medida activa (por ejemplo, 33ML).
    // El array localProductosMultiples se actualiza para mantener un registro de los datos del producto de cada unidad de medida.
    actualizarCamposComunes() {
      if ((this.crearMultiplesProductosByUdsMedida && this.localProductosMultiples.length > 0) ||
        (this.productoSeleccionado.MostrarEnListaCON && this.productoSeleccionado.MostrarEnListaSUPLEMENTO)) {

        // Actualizar localProductosMultiples para el índice activo
        this.$set(this.localProductosMultiples[this.indexProductoActivo], 'producto', {
          ...this.localProductosMultiples[this.indexProductoActivo].producto,
          nombreProducto: this.producto.nombreProducto,
          descripcion: this.producto.descripcion,
          codigoBarras: this.producto.codigoBarras,
          color: this.producto.color,
          selPrice1: this.producto.selPrice1,
          namePrice1: this.producto.namePrice1,
          selPrice2: this.producto.selPrice2,
          namePrice2: this.producto.namePrice2,
          selPrice3: this.producto.selPrice3,
          namePrice3: this.producto.namePrice3,
          selPrice4: this.producto.selPrice4,
          namePrice4: this.producto.namePrice4,
          orden: this.producto.orden,
          baja: this.producto.baja,
          descuento: this.producto.descuento,
          isMenu: this.producto.isMenu,
          isClosed: this.producto.isClosed,
        });

        // Actualiza solo los productosPorTpv con el multiProductoIndex correspondiente
        this.productosPorTpv.forEach((producto, index) => {
          if (producto.multiProductoIndex === this.indexProductoActivo) {
            this.$set(this.productosPorTpv, index, {
              ...producto,
              nombreProducto: this.producto.nombreProducto,
              descripcion: this.producto.descripcion,
              codigoBarras: this.producto.codigoBarras,
              color: this.producto.color,
              selPrice1: this.producto.selPrice1,
              namePrice1: this.producto.namePrice1,
              selPrice2: this.producto.selPrice2,
              namePrice2: this.producto.namePrice2,
              selPrice3: this.producto.selPrice3,
              namePrice3: this.producto.namePrice3,
              selPrice4: this.producto.selPrice4,
              namePrice4: this.producto.namePrice4,
              orden: this.producto.orden,
              baja: this.producto.baja,
              descuento: this.producto.descuento,
              isMenu: this.producto.isMenu,
              isClosed: this.producto.isClosed,
            });
          }
        });
      } else {
        // console.log("ES-3");
        // Comportamiento original para un solo producto
        this.productosPorTpv.forEach((producto, index) => {
          this.$set(this.productosPorTpv, index, {
            ...producto,
            nombreProducto: this.producto.nombreProducto,
            descripcion: this.producto.descripcion,
            codigoBarras: this.producto.codigoBarras,
            color: this.producto.color,
            selPrice1: this.producto.selPrice1,
            namePrice1: this.producto.namePrice1,
            selPrice2: this.producto.selPrice2,
            namePrice2: this.producto.namePrice2,
            selPrice3: this.producto.selPrice3,
            namePrice3: this.producto.namePrice3,
            selPrice4: this.producto.selPrice4,
            namePrice4: this.producto.namePrice4,
            orden: this.producto.orden,
            baja: this.producto.baja,
            descuento: this.producto.descuento,
            isMenu: this.producto.isMenu,
            isClosed: this.producto.isClosed,
          });
        });
      }
      // console.log(" > Productos actualizados:", this.productosPorTpv);
      // console.log(" > Productos actualizados:", JSON.parse(JSON.stringify(this.productosPorTpv)));
    },

    // 1️. Verifica que los productos tengan los campos requeridos antes de enviarlos al servidor.
    // 2️. Consulta si los códigos de barras ya existen en la base de datos.
    // 3️. Si hay duplicados, muestra una alerta y detiene el proceso.
    // 4️. Si no hay errores, guarda los productos y emite un evento de éxito.
    checkBarCodeProd() {
      // console.log('continueButtonPressedOnStep3 - basico');
      // Llamamos a checkCampos para validar campos obligatorios
      if (!this.checkCampos()) {
        return;
      }
      // console.log("prod", this.producto);
      // console.log("prodActivo", this.productoActivo);

      this.productosPorTpv.forEach((prod, index) => {
        prod.namePrice1 = this.producto.namePrice1;
        prod.namePrice2 = this.producto.namePrice2;
        prod.namePrice3 = this.producto.namePrice3;
        prod.namePrice4 = this.producto.namePrice4;
      });

      // console.log(" > Iniciando verificación de códigos de barras...");

      // Comprobación previa: verificar que los códigos de barras no coincidan entre diferentes formatos
      if (this.crearMultiplesProductosByUdsMedida && this.localProductosMultiples.length > 1) {
        const codigosBarras = this.localProductosMultiples.map((multiProducto) => multiProducto.producto.codigoBarras.trim());
        const codigosUnicos = new Set(codigosBarras.filter((codigo) => codigo !== "")); // Excluir códigos vacíos

        // Si el tamaño del Set es menor que el número de códigos no vacíos, hay duplicados
        const codigosNoVacios = codigosBarras.filter((codigo) => codigo !== "");
        if (codigosUnicos.size < codigosNoVacios.length) {
          Swal.fire({
            title: this.$t("atencion"),
            text: this.$t("noPuedenCoincidirLosValoresDeLosCodigosDeBarrasEntreDiferentesFormatos"),
            type: "error",
            confirmButtonText: this.$t("vale"),
          });
          return;
        }
      }

      this.loadingGeneral = Loading.service({ text: this.$t('cargando') });
      // console.log("Verificamos códigos de barras...");

      const auxProds = JSON.parse(JSON.stringify(this.productosPorTpv));

      // console.log("> Los putos portpv", auxProds);

      const finalProducts = auxProds.map(({ idTpvServer, codigoBarras }) => ({ idTpvServer, codigoBarras }));


      let config = {
        params: {
          jwt: this.$store.getters.jwt,
          productos: JSON.stringify(finalProducts),
          actualizandoProductos: JSON.stringify(this.productsDataToFillForm.length > 0)
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var params = {
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      this.axios
        .post(this.$store.getters.apiUrl + "products/checkBarCodeProd", params, config)
        .then((response) => {
          if (!response.data.response) {
            // Si hay productos repetidos, mostrar alerta y detener el proceso
            if (response.data.productosRepetidos) {
              console.warn("Códigos de barras con conflictos:", response.data.productosRepetidos);
              Swal.fire({
                title: this.$t("atencion"),
                text: this.$t("yaExisteUnProductoConEseCodigoDeBarras"),
                type: "error",
                confirmButtonText: this.$t("vale"),
              });
              vm.loadingGeneral.close();

            } else {
              console.error("Error en checkBarCodeProd:", response.data.message);
              Swal.fire({
                title: this.$t("error"),
                text: response.data.message,
                type: "error",
                confirmButtonText: this.$t("vale"),
              });
              vm.loadingGeneral.close();
            }
            return;
          }
          this.$emit("continue-to-step4", this.productosPorTpv);
          vm.loadingGeneral.close();
        })
        .catch((error) => {
          console.error("Error en checkBarCodeProd:", error.message);
          Swal.fire({
            title: this.$t("error"),
            text: this.$t("serverError"),
            type: "error",
            confirmButtonText: this.$t("vale"),
          });
        });
    },

    // 1️. Valida los campos obligatorios de cada producto (nombre, color, categoría, tipo de IVA).
    // 2️. Si falta algún campo, muestra una alerta con los errores y detiene el proceso.
    // Caso a) Cuando crearMultiplesProductosByUdsMedida es true, validar los campos obligatorios (nombre, color, categoría, IVA) para cada producto en localProductosMultiples y mostrar errores
    //  específicos por tab/unidad de medida.
    // Caso b) Cuando crearMultiplesProductosByUdsMedida es false pero productoSeleccionado.udMedida.length > 1, mantener el comportamiento actual.
    // Caso c) Cuando el producto tiene una sola unidad de medida (productoSeleccionado.udMedida.length <= 1), mantener el comportamiento actual.
    checkCampos() {
      // Evitar mensajes duplicados
      let errores = new Set();

      // Caso a: crearMultiplesProductosByUdsMedida es true
      if (this.crearMultiplesProductosByUdsMedida && this.localProductosMultiples.length > 0) {
        this.localProductosMultiples.forEach((multiProducto, index) => {
          const unidad = multiProducto.unidad; // Nombre de la tab (ej: "BOTELLA", "LITRO")
          const producto = multiProducto.producto;

          // Validación de nombreProducto
          if (!producto.nombreProducto || producto.nombreProducto.length === 0) {
            errores.add(
              this.$t("swalNombreProductoObligatorioFromProductosBusinessCentralText") +
              ` del formato "${unidad}".`
            );
          } else if (producto.nombreProducto.length > this.maxNameProducts) {
            errores.add(
              this.$t("laLongitudDelNombreNoPuedeSerMayorDe") +
              this.maxNameProducts +
              ` del formato "${unidad}".`
            );
          }

          // Validación de color
          if (!producto.color || producto.color.length === 0) {
            errores.add(
              this.$t("swalColorObligatorioFromProductosBusinessCentralText") +
              ` del formato "${unidad}".`
            );
          }

          // Validación de categoría e IVA por TPV para este producto múltiple
          let faltaCategoria = false;
          let faltaTipoIva = false;

          // Filtramos productosPorTpv que corresponden al multiProductoIndex actual
          const productosPorTpvFiltrados = this.productosPorTpv.filter(
            (prod) => prod.multiProductoIndex === index
          );
          for (let prod of productosPorTpvFiltrados) {
            if (!prod.idCategory) faltaCategoria = true;
            if (prod.tipoIva === null || prod.tipoIva === undefined || prod.tipoIva === "") faltaTipoIva = true;
          }

          if (faltaCategoria) {
            errores.add(
              this.$t("swalCategoriaObligatorioFromProductosBusinessCentralText") +
              ` del formato "${unidad}".`
            );
          }
          if (faltaTipoIva) {
            errores.add(
              this.$t("swalTipoIvaObligatorioFromProductosBusinessCentralText") +
              ` del formato "${unidad}".`
            );
          }
        });
      } else {
        // Casos b y c: crearMultiplesProductosByUdsMedida es false o producto con una sola unidad de medida
        // Validación de nombreProducto
        if (!this.producto.nombreProducto || this.producto.nombreProducto.length === 0) {
          errores.add(this.$t("swalNombreProductoObligatorioFromProductosBusinessCentralText"));
        } else if (this.producto.nombreProducto.length > this.maxNameProducts) {
          errores.add(
            this.$t("laLongitudDelNombreNoPuedeSerMayorDe") + this.maxNameProducts + "."
          );
        }

        // Validación de color
        if (!this.producto.color || this.producto.color.length === 0) {
          errores.add(this.$t("swalColorObligatorioFromProductosBusinessCentralText"));
        }

        // Validación de categoría e IVA
        let faltaCategoria = false;
        let faltaTipoIva = false;

        for (let producto of this.productosPorTpv) {
          if (!producto.idCategory) faltaCategoria = true;
          if (producto.tipoIva === null || producto.tipoIva === undefined || producto.tipoIva === "") faltaTipoIva = true;
        }

        if (faltaCategoria) {
          errores.add(this.$t("swalCategoriaObligatorioFromProductosBusinessCentralText"));
        }
        if (faltaTipoIva) {
          errores.add(this.$t("swalTipoIvaObligatorioFromProductosBusinessCentralText"));
        }
      }

      // Validación adicional: si existe producto SUPLEMENTO, Tarifa 1 (price1) es obligatoria (> 0) por TPV
      const productosSuplemento = this.productosPorTpv.filter(
        (p) => ((p.PLU3 || '').toString().toUpperCase() === 'SUPLEMENTO')
      );
      if (productosSuplemento.length > 0) {
        const obtenerNombreTpv = (id) => {
          const t = this.selectedTpvServerList.find(x => x.idTpvServer == id);
          return t ? (t.nameShow || t.idTpvServer) : id;
        };
        productosSuplemento.forEach((prod) => {
          const precio = Number(prod.price1 || 0);
          // if (!(precio > 0)) {
          //   errores.add(`Falta precio de SUPLEMENTO (Tarifa 1) en el departamento/TPV "${obtenerNombreTpv(prod.idTpvServer)}".`);
          // }
          if (!(precio > 0)) {
            errores.add(
              this.$t('swalSuplementoTarifa1ObligatoriaFromProductosBusinessCentralText')
                .replace('{tpv}', obtenerNombreTpv(prod.idTpvServer))
            );
          }
        });
      }

      // Si hay errores, mostramos modal y devolvemos false
      if (errores.size > 0) {
        Swal.fire({
          title: this.$t("atencion"),
          html: `<div>${this.$t("swalCamposObligatoriosFromProductosBusinessCentralText")}</div><div style="text-align: left;"><br><ul><li>${[...errores].join(
            "</li><li>"
          )}</li></ul></div>`,
          confirmButtonClass: "btn btn-info btn-fill",
          type: "info",
        });
        return false;
      }

      // Si no hay errores, continuar con el guardado
      return true;
    },

    resetForm() {
      // console.log(" > Comienza el resetForm");

      this.productosPorTpv = [];
      this.categoryListBySelectedTpvServerList = [];
      this.listIva = [];
      this.namePriceHeaders = ["Tarifa 1", "Tarifa 2", "Tarifa 3", "Tarifa 4"];
      this.platos = [
        { nombrePlato: "", idPlato: 1 },
        { nombrePlato: "", idPlato: 2 },
        { nombrePlato: "", idPlato: 3 },
        { nombrePlato: "", idPlato: 4 },
        { nombrePlato: "", idPlato: 5 },
        { nombrePlato: "", idPlato: 6 },
      ];
      this.replicarTarifas = false;
      this.productDataInfo = {};

      // Reseteo de `producto`
      this.producto = {
        id: 0,
        orden: 999,
        idCategory: null,
        tipoIva: 0,
        xname: "",
        nombreProducto: "",
        descripcion: "",
        codigoBarras: "",
        color: "",
        baja: false,
        descuento: false,
        isMenu: false,
        isClosed: false,
        selPrice1: false,
        selPrice2: false,
        selPrice3: false,
        selPrice4: false,
        namePrice1: "",
        namePrice2: "",
        namePrice3: "",
        namePrice4: "",
        price1: 0,
        price2: 0,
        price3: 0,
        price4: 0
      };

      this.localProductosMultiples = [];
      this.indexProductoActivo = 0;
      //this.productsDataToFillForm = []; // es una prop, no se puede mutar, solo lectura
      this.tarifasBloqueadas = false;
      this.numTarifasActivas = 4;

      // console.log("termina el resetForm y productosPorTpv", this.productosPorTpv);
      // console.log("termina el resetForm y producto", this.producto);
      // console.log("termina el resetForm y namePriceHeaders", this.namePriceHeaders);

      this.$emit("form_has_been_reset");
    },

    // Obtenemos los IDs de TPVs seleccionados y los de productos recuperados.
    // Si todos coinciden, no se ha cambiado la selección en el step2, y directamente asignamos el valor de productosPorTpvRecuperados a productosPorTpv
    // Si no todos coinciden...
    // 1.- llamamos a inicializarProductosPorTpv() para tener tantos como tpvs seleccionados
    // 2.- Llamamos a actualizarCamposComunes() que son los valores recuperados (el estado anterior de los campos comunes del formulario guardado ahora en this.producto)
    // 3.- Llamamoso a checkChangesSelectedTpvList() para verificar si en la nueva selección hay tpvs coincidentes, nuevos o deseleccionados para restaurar valores de campos específicos. 
    checkProductosPorTpvRecuperados() {
      const selectedTpvServerIdList = this.selectedTpvServerList.map(tpv => tpv.idTpvServer);
      const productosPorTpvRecuperadosIdList = this.productosPorTpvRecuperados.map(product => product.idTpvServer);

      // Verificamos que todos los ids de la lista de Tpvs se incluyen en la lista de ids de productosRecuperados, y viceversa.
      const todosLosIdCoinciden = selectedTpvServerIdList.every(id => productosPorTpvRecuperadosIdList.includes(id)) &&
        productosPorTpvRecuperadosIdList.every(id => selectedTpvServerIdList.includes(id));

      if (todosLosIdCoinciden) {
        // console.log(" > No hay cambios en la lista de Tpvs Seleccionados");
        this.productosPorTpv = [...this.productosPorTpvRecuperados];
      } else {
        // console.log(" > Hay cambios en la lista de Tpvs Seleccionados");

        // Iniciamos productos por TPV con la nueva selección de TPVs
        this.inicializarProductosPorTpv()
        // Actualizamos los campos comunes con los valores recuperados, guardados en la variable local this.producto
        this.actualizarCamposComunes()
        // Vemos si alguno de los Tpvs seleccionados coinciden con la seleccion anterior para restaurar los valores específicos
        this.checkChangesSelectedTpvList();
      }
    },

    // Identificamos cuáles TPVs coinciden, cuáles son nuevos y cuáles han sido deseleccionados.
    // Si hay coincidentes restauramos los valores de los campos específicos que tenía antes. 
    // Si no, como ya se han inicializado con valor predeterminado, no hay que hacer más nada. 
    checkChangesSelectedTpvList() {
      const selectedTpvServerIdList = this.selectedTpvServerList.map(tpv => tpv.idTpvServer);
      const productosPorTpvRecuperadosIdList = this.productosPorTpvRecuperados.map(product => product.idTpvServer);

      // 1️. Identificar TPVs que coinciden, nuevos y deseleccionados
      const tpvsCoincidentes = selectedTpvServerIdList.filter(id => productosPorTpvRecuperadosIdList.includes(id));
      const tpvsNuevos = selectedTpvServerIdList.filter(id => !productosPorTpvRecuperadosIdList.includes(id));
      const tpvsDeseleccionados = productosPorTpvRecuperadosIdList.filter(id => !selectedTpvServerIdList.includes(id));

      // console.log(" > TPVs Coincidentes:", tpvsCoincidentes);
      // console.log(" > TPVs Nuevos:", tpvsNuevos);
      // console.log(" > TPVs Deseleccionados:", tpvsDeseleccionados);

      // 2️. Para cada TPV coincidente, copiar valores específicos al producto correspondiente en productosPorTpv
      this.productosPorTpv = this.productosPorTpv.map(producto => {
        if (tpvsCoincidentes.includes(producto.idTpvServer)) {
          let productoRecuperado;

          if (this.crearMultiplesProductosByUdsMedida) {
            // Caso 3: buscar por TPV + multiProductoIndex
            productoRecuperado = this.productosPorTpvRecuperados.find(
              p => p.idTpvServer == producto.idTpvServer && p.multiProductoIndex == producto.multiProductoIndex
            );
          } else {
            // Caso simple o normal
            productoRecuperado = this.productosPorTpvRecuperados.find(
              p => p.idTpvServer === producto.idTpvServer
            );
          }

          if (productoRecuperado) {
            return {
              ...producto,
              idCategory: productoRecuperado.idCategory,
              // Un producto que ya existe conserva su IVA, aunque sea 0. Solo si
              // viniera vacío nos quedamos con el que ya calculó initProductosPorTpv,
              // que es el caso de un formato nuevo dentro de un producto ya creado.
              tipoIva: (productoRecuperado.tipoIva !== null && productoRecuperado.tipoIva !== undefined)
                ? productoRecuperado.tipoIva
                : producto.tipoIva,
              price1: productoRecuperado.price1,
              price2: productoRecuperado.price2,
              price3: productoRecuperado.price3,
              price4: productoRecuperado.price4
            };
          }
        }

        return producto;
      });
      // console.log(" > Productos actualizados en productosPorTpv:", this.productosPorTpv);
    },

    fillFormByProductData() {
      const mapped = this.mapearProductsDataToProductosPorTpv(this.productsDataToFillForm);

      // Añadir idBusiness desde selectedTpvServerList
      this.productosPorTpv = mapped.map(prod => {
        const tpv = this.selectedTpvServerList.find(t => t.idTpvServer == prod.idTpvServer);
        return {
          ...prod,
          idBusiness: tpv ? tpv.idBusiness : null
        };
      });


      // console.log(" > productosPorTpv mapeado desde productsDataToFillForm:", JSON.parse(JSON.stringify(this.productosPorTpv)));

      const primerProducto = this.productosPorTpv[0]; // común en todos los casos

      // Detectar caso (basado en PLU2 del primer producto)
      const tipoProducto = primerProducto.PLU2;

      if (tipoProducto === "Formatos") {

        // Forzamos cambio de tab al último y luego al primero para activar el render
        const ultimoIndex = this.localProductosMultiples.length - 1;
        this.$nextTick(() => {
          this.indexProductoActivo = ultimoIndex;

          // Volvemos al primer tab después de un breve delay
          setTimeout(() => {
            this.indexProductoActivo = 0;
          }, 50);
        });

        // console.log(" > [CASO 3] Producto cargado para formato:", this.producto);

      } else {
        // CASO 1 y 2 → usamos el primer producto
        this.producto.nombreProducto = primerProducto.nombreProducto || "";
        this.producto.descripcion = primerProducto.descripcion || "";
        this.producto.codigoBarras = primerProducto.codigoBarras || "";
        this.producto.color = primerProducto.color || "";
        this.producto.orden = primerProducto.orden;
        this.producto.baja = primerProducto.baja;
        this.producto.descuento = primerProducto.descuento;
        this.producto.isMenu = primerProducto.isMenu;
        this.producto.isClosed = primerProducto.isClosed;
        this.producto.namePrice1 = primerProducto.namePrice1;
        this.producto.namePrice2 = primerProducto.namePrice2;
        this.producto.namePrice3 = primerProducto.namePrice3;
        this.producto.namePrice4 = primerProducto.namePrice4;
        this.producto.selPrice1 = primerProducto.selPrice1;
        this.producto.selPrice2 = primerProducto.selPrice2;
        this.producto.selPrice3 = primerProducto.selPrice3;
        this.producto.selPrice4 = primerProducto.selPrice4;
        // console.log(" > [CASO 1/2] Producto cargado:", this.producto);
      }

      // Actualizar los encabezados de las tarifas
      this.updateHeaders();
    },

    mapearProductsDataToProductosPorTpv(products) {
      // console.log("HA-5");
      const toBool = val => val === "1";
      const toNum = val => isNaN(val) ? 0 : parseFloat(val);
      const toInt = val => parseInt(val) || 0;

      return products.map(prod => ({
        PLU1: prod.PLU1 || "",
        PLU2: prod.PLU2 || "",
        PLU3: prod.PLU3 || "",
        PLU4: prod.PLU4 || "",
        codigoBarras: prod.barCode || "",
        color: prod.color || "",
        copiaImpresionKDSPDA: prod.kds_pda_copia || "Ninguna seleccionada",
        copiaImpresionKDSTPV: prod.kds_copia || "Ninguna seleccionada",
        copiaImpresionPlano1: prod.impresora_pl1_copia || "Ninguna seleccionada",
        copiaImpresionPlano2: prod.impresora_pl2_copia || "Ninguna seleccionada",
        copiaImpresionPlano3: prod.impresora_pl3_copia || "Ninguna seleccionada",
        copiaImpresionPlano4: prod.impresora_pl4_copia || "Ninguna seleccionada",
        copiaImpresionPlano5: prod.impresora_pl5_copia || "Ninguna seleccionada",
        copiaImpresionPlano6: prod.impresora_pl6_copia || "Ninguna seleccionada",
        copiaImpresionPlano7: prod.impresora_pl7_copia || "Ninguna seleccionada",
        copiaImpresionPlano8: prod.impresora_pl8_copia || "Ninguna seleccionada",
        copiaImpresionPlanoKDS1: prod.kds_pl1_copia || "Ninguna seleccionada",
        copiaImpresionPlanoKDS2: prod.kds_pl2_copia || "Ninguna seleccionada",
        copiaImpresionPlanoKDS3: prod.kds_pl3_copia || "Ninguna seleccionada",
        copiaImpresionPlanoKDS4: prod.kds_pl4_copia || "Ninguna seleccionada",
        copiaImpresionPlanoKDS5: prod.kds_pl5_copia || "Ninguna seleccionada",
        copiaImpresionPlanoKDS6: prod.kds_pl6_copia || "Ninguna seleccionada",
        copiaImpresionPlanoKDS7: prod.kds_pl7_copia || "Ninguna seleccionada",
        copiaImpresionPlanoKDS8: prod.kds_pl8_copia || "Ninguna seleccionada",
        descripcion: prod.description || "",
        descuento: toBool(prod.isDto),
        baja: !toBool(prod.active),
        id: toInt(prod.id),
        idBusiness: null, // Se rellena luego a partir del selectedTpvServerList
        idCategory: toInt(prod.idCategory),
        idCuenta: prod.idCuenta || "0",
        idCuenta2: prod.idCuenta2 || "0",
        idCuenta3: prod.idCuenta3 || "0",
        idTpvServer: prod.idTpv,
        importe: false,
        impresionKDSPDA: "", // No hay equivalencia directa
        impresionKDSTPV: "",
        impresionPlano1: prod.impresora_pl1 || "Ninguna seleccionada",
        impresionPlano2: prod.impresora_pl2 || "Ninguna seleccionada",
        impresionPlano3: prod.impresora_pl3 || "Ninguna seleccionada",
        impresionPlano4: prod.impresora_pl4 || "Ninguna seleccionada",
        impresionPlano5: prod.impresora_pl5 || "Ninguna seleccionada",
        impresionPlano6: prod.impresora_pl6 || "Ninguna seleccionada",
        impresionPlano7: prod.impresora_pl7 || "Ninguna seleccionada",
        impresionPlano8: prod.impresora_pl8 || "Ninguna seleccionada",
        impresionPlanoKDS1: prod.kds_pl1 || "Ninguna seleccionada",
        impresionPlanoKDS2: prod.kds_pl2 || "Ninguna seleccionada",
        impresionPlanoKDS3: prod.kds_pl3 || "Ninguna seleccionada",
        impresionPlanoKDS4: prod.kds_pl4 || "Ninguna seleccionada",
        impresionPlanoKDS5: prod.kds_pl5 || "Ninguna seleccionada",
        impresionPlanoKDS6: prod.kds_pl6 || "Ninguna seleccionada",
        impresionPlanoKDS7: prod.kds_pl7 || "Ninguna seleccionada",
        impresionPlanoKDS8: prod.kds_pl8 || "Ninguna seleccionada",
        isClosed: toBool(prod.isClosed),
        isMenu: toBool(prod.isMenu),
        mostrarPC: toBool(prod.showPc),
        mostrarPDA: toBool(prod.showPda),
        namePrice1: prod.namePrice1 || "ouou",
        namePrice2: prod.namePrice2 || "ouou",
        namePrice3: prod.namePrice3 || "ouou",
        namePrice4: prod.namePrice4 || "ouou",
        selPrice1: toBool(prod.selPrice1),
        selPrice2: toBool(prod.selPrice2),
        selPrice3: toBool(prod.selPrice3),
        selPrice4: toBool(prod.selPrice4),
        noImprimir: toBool(prod.noPrint),
        nombreProducto: prod.name || "",
        numOpcionales: 0,
        numPlato: toInt(prod.numPlats),
        opcion1: prod.modifier1 || "",
        opcion2: prod.modifier2 || "",
        opcion3: prod.modifier3 || "",
        opcion4: prod.modifier4 || "",
        opcion5: prod.modifier5 || "",
        orden: toInt(prod.orderCode),
        peso: toBool(prod.askWeight),
        porcentajeContable: toNum(prod.porcentajeContable),
        porcentajeContable2: toNum(prod.porcentajeContable2),
        porcentajeContable3: toNum(prod.porcentajeContable3),
        precio: false,
        precioCoste: toNum(prod.costprice),
        precioCoste2: toNum(prod.costprice2),
        precioCoste3: toNum(prod.costprice3),
        precioCoste4: toNum(prod.costprice4),
        precioCosteSinIVA: toNum(prod.costpriceNoIVA),
        precioCosteSinIVA2: toNum(prod.costpriceNoIVA2),
        precioCosteSinIVA3: toNum(prod.costpriceNoIVA3),
        precioCosteSinIVA4: toNum(prod.costpriceNoIVA4),
        price1: toNum(prod.price1),
        price2: toNum(prod.price2),
        price3: toNum(prod.price3),
        price4: toNum(prod.price4),
        printerName: prod.printerTpv || "Ninguna seleccionada",
        printerName2: prod.printerSecondary || "Ninguna seleccionada",
        printerPDAName: prod.printerPda || "Ninguna seleccionada",
        printerPDAName2: prod.printerPDASecondary || "Ninguna seleccionada",
        promocionable: toBool(prod.promotable),
        seleccionarIngredientes: toBool(prod.activeIngredients),
        subproductos: [],
        tipoIva: toInt(prod.vatType),
        xname: "",
        code: prod.code || "",
        grupo_enlazado: prod.grupo_enlazado !== undefined ? prod.grupo_enlazado : null,
        // Solo para el caso 3
        multiProductoIndex: prod.multiProductoIndex !== undefined ? prod.multiProductoIndex : 0
      }));
    },

    isProductoMultipleCompleto(producto, index) {
      // Validar nombreProducto
      if (!producto.nombreProducto || producto.nombreProducto.length === 0) {
        return false;
      }
      // Validar longitud máxima de nombreProducto
      if (producto.nombreProducto.length > this.maxNameProducts) {
        return false;
      }
      // Validar color
      if (!producto.color || producto.color.length === 0) {
        return false;
      }
      // Validar categoría e IVA para todos los departamentos del multiProductoIndex correspondiente
      const productosPorTpvFiltrados = this.productosPorTpv.filter(
        (prod) => prod.multiProductoIndex === index
      );
      for (let prod of productosPorTpvFiltrados) {
        if (!prod.idCategory) {
          return false;
        }
        if (prod.tipoIva === null || prod.tipoIva === undefined) {
          return false;
        }
      }
      return true;
    },

    // Método que encuentra el producto en productosPorTpv que coincide con el TPV y el multiProductoIndex activo.
    getProductoForTpv(idTpvServer) {
      // Si estamos en modo de creación de múltiples productos
      if (this.crearMultiplesProductosByUdsMedida ||
        (this.productoSeleccionado && this.productoSeleccionado.MostrarEnListaCON && this.productoSeleccionado.MostrarEnListaSUPLEMENTO)) {
        // Intentamos encontrar una coincidencia exacta
        const exactMatch = this.productosPorTpv.find(
          p => p.idTpvServer == idTpvServer && p.multiProductoIndex == this.indexProductoActivo
        );

        // Si no hay coincidencia exacta, intentamos encontrar cualquier producto para este TPV
        if (!exactMatch) {
          const anyProductForTpv = this.productosPorTpv.find(p => p.idTpvServer == idTpvServer);
          if (anyProductForTpv) {
            // Actualizamos el índice actual
            this.$set(anyProductForTpv, 'multiProductoIndex', this.indexProductoActivo);
            return anyProductForTpv;
          }
        }
        return exactMatch || {};
      }

      // Modo de un solo producto
      return this.productosPorTpv.find(p => p.idTpvServer == idTpvServer) || {};
    },

    getProductoUnicoPorTpv(tpvId, multiIndex = 0) {
      if (!this.productosPorTpvMap) this.productosPorTpvMap = {};

      if (!this.productosPorTpvMap[tpvId]) {
        this.productosPorTpvMap[tpvId] = [];
      }

      if (!this.productosPorTpvMap[tpvId][multiIndex]) {
        this.productosPorTpvMap[tpvId][multiIndex] = {
          idTpvServer: tpvId,
          idCategory: null,
          grupo_enlazado: null
        };
      }

      return this.productosPorTpvMap[tpvId][multiIndex];
    },

    getCategoriaEnlazada(idTpvServer) {
      const producto = this.getProductoForTpv(idTpvServer);
      if (!producto || !producto.grupo_enlazado) return '';

      // Buscar en todas las categorías de todos los TPVs
      for (const business of this.listCategoriesByBusiness || []) {
        for (const category of business.categories || []) {
          if (String(category.id) === String(producto.grupo_enlazado)) {
            return category.name;
          }
        }
      }
      return '';
    },

    isEmptyObject(args) {
      return JSON.stringify(args) === '{}';
    },

    clearObjectProperties(obj) {
      Object.keys(obj).forEach(key => {
        obj[key] = '';
      })
    },

    // Método para actualizar el campo especifico de categoria solo para el producto correspondiente. 
    updateCategoryForTpv(idTpvServer, value) {
      if (this.crearMultiplesProductosByUdsMedida || (this.productoSeleccionado.MostrarEnListaCON && this.productoSeleccionado.MostrarEnListaSUPLEMENTO)) {
        const index = this.productosPorTpv.findIndex(
          p => p.idTpvServer == idTpvServer && p.multiProductoIndex == this.indexProductoActivo
        );
        if (index !== -1) {
          // Si la nueva categoría es igual a la enlazada, quitamos la enlazada
          if (this.productosPorTpv[index].grupo_enlazado && String(this.productosPorTpv[index].grupo_enlazado) === String(value)) {
            this.$set(this.productosPorTpv[index], 'grupo_enlazado', null);
          }
          this.$set(this.productosPorTpv[index], 'idCategory', value);
        }
      } else {
        const index = this.productosPorTpv.findIndex(p => p.idTpvServer == idTpvServer);
        if (index !== -1) {
          // Si la nueva categoría es igual a la enlazada, quitamos la enlazada
          if (this.productosPorTpv[index].grupo_enlazado && String(this.productosPorTpv[index].grupo_enlazado) == String(value)) {
            this.$set(this.productosPorTpv[index], 'grupo_enlazado', null);
          }
          this.$set(this.productosPorTpv[index], 'idCategory', value);

        } else {
          const producto = this.getProductoForTpv(idTpvServer);

          if (this.isEmptyObject(producto)) {
            const newProd = { ...this.productosPorTpv[0] };

            this.clearObjectProperties(newProd);

            newProd.idTpvServer = idTpvServer;
            newProd.idCategory = value;
            // Al ser nuevo, grupo_enlazado será null/vacío por defecto tras clearObjectProperties

            this.productosPorTpv.push(newProd);
          }
        }
      }
    },

    updateLinkedCategoryForTpv(idTpvServer, value) {
      let productToCheck = null;
      // Normalizamos el valor: null, "0", 0 o "" pasan a ser null
      const processedValue = (value === null || value === "0" || value === 0 || value === "") ? null : value;

      if (this.crearMultiplesProductosByUdsMedida || (this.productoSeleccionado.MostrarEnListaCON && this.productoSeleccionado.MostrarEnListaSUPLEMENTO)) {
        productToCheck = this.productosPorTpv.find(p => p.idTpvServer === idTpvServer && p.multiProductoIndex === this.indexProductoActivo);
      } else {
        productToCheck = this.productosPorTpv.find(p => p.idTpvServer === idTpvServer);
      }

      if (productToCheck && productToCheck.idCategory && String(productToCheck.idCategory) === String(processedValue)) {
        // No permitir seleccionar la misma categoría que la principal
        this.$set(productToCheck, 'grupo_enlazado', null);
        return;
      }

      const index = this.productosPorTpv.findIndex(
        p => p.idTpvServer == idTpvServer &&
          (
            (!this.crearMultiplesProductosByUdsMedida && !(this.productoSeleccionado.MostrarEnListaCON && this.productoSeleccionado.MostrarEnListaSUPLEMENTO)) ||
            p.multiProductoIndex == this.indexProductoActivo
          )
      );

      if (index !== -1) {
        this.$set(this.productosPorTpv[index], 'grupo_enlazado', processedValue);
      } else {
        const producto = this.getProductoForTpv(idTpvServer);
        if (this.isEmptyObject(producto)) {
          const newProd = { ...this.productosPorTpv[0] };
          this.clearObjectProperties(newProd);
          newProd.idTpvServer = idTpvServer;
          newProd.grupo_enlazado = processedValue;
          this.productosPorTpv.push(newProd);
        }
      }
    },

    // Método para actualizar el campo especifico de IVA solo para el producto correspondiente.
    updateIvaForTpv(idTpvServer, value) {
      // console.log(` > Actualizando tipoIva para idTpvServer: ${idTpvServer}, multiProductoIndex: ${this.indexProductoActivo}, valor: ${value}`);
      // console.log(" > productosPorTpv después de actualizar:", JSON.parse(JSON.stringify(this.productosPorTpv)));

      if (this.crearMultiplesProductosByUdsMedida || (this.productoSeleccionado.MostrarEnListaCON && this.productoSeleccionado.MostrarEnListaSUPLEMENTO)) {


        const index = this.productosPorTpv.findIndex(
          p => p.idTpvServer == idTpvServer && p.multiProductoIndex == this.indexProductoActivo
        );
        if (index !== -1) {
          this.$set(this.productosPorTpv[index], 'tipoIva', value);
        }
      } else {
        const index = this.productosPorTpv.findIndex(p => p.idTpvServer == idTpvServer);
        if (index !== -1) {
          this.$set(this.productosPorTpv[index], 'tipoIva', value);
        } {
          const producto = this.getProductoForTpv(idTpvServer);

          if (this.isEmptyObject(producto)) {
            const newProd = { ...this.productosPorTpv[0] };

            this.clearObjectProperties(newProd);

            newProd.idTpvServer = idTpvServer;
            newProd.tipoIva = value;

            this.productosPorTpv.push(newProd);

          }
        }
      }
    },

    // Configura las tarifas (namePrice, selPrice, y price) en función de las unidades de medida. Para productos con varias unidades de medida y elección de crear 1 solo producto, 
    // rellena los namePrice, marca los checkboxes y bloquea la edicion. Además, de las tarifas restantes (sobrantes) las bloquea. Para los demas casos deja editar. 
    configTarifasByUdsMedida() {
      // console.log(" > Iniciando configTarifasByUdsMedida");
      // console.log("this.productoSeleccionado", this.productoSeleccionado);

      const eraMultiUD =
        this.productoSeleccionado &&
        (this.productoSeleccionado.PLU2 === "Tarifas" ||
          this.productoSeleccionado.PLU2 === "Formatos");

      const ahoraSoloUnaUD =
        this.productoSeleccionado &&
        this.productoSeleccionado.udMedida &&
        this.productoSeleccionado.udMedida.length === 1;

      if (eraMultiUD && ahoraSoloUnaUD) {
        // console.log("DOWNGRADE detectado → limpiar tarifas");

        this.tarifasBloqueadas = false;

        for (let i = 1; i <= 4; i++) {
          this.$set(this.producto, `namePrice${i}`, "");
          this.$set(this.producto, `selPrice${i}`, false);
          this.$set(this.producto, `price${i}`, 0);
        }

        if (this.productosPorTpv.length) {
          this.productosPorTpv = this.productosPorTpv.map(tpv => {
            const nuevo = { ...tpv };
            for (let i = 1; i <= 4; i++) {
              nuevo[`namePrice${i}`] = "";
              nuevo[`selPrice${i}`] = false;
              nuevo[`price${i}`] = 0;
            }
            return nuevo;
          });
        }

        this.actualizarCamposComunes();
        this.updateHeaders();
        this.numTarifasActivas = 1; // Downgrade: solo 1 tarifa

        return;
      }
      let esTarifas = false;
      let firstTpvId = null;
      let firstTpv = null;

      // Comprobar si tenemos productDataInfo con datos de tarifas
      const hasProductDataInfo =
        this.productDataInfo &&
        this.productDataInfo.tpvs &&
        Object.keys(this.productDataInfo.tpvs).length > 0;

      if (hasProductDataInfo) {
        const tpvKeys = Object.keys(this.productDataInfo.tpvs);
        firstTpvId = tpvKeys[0];
        firstTpv = this.productDataInfo.tpvs[firstTpvId];

        if (
          firstTpv &&
          firstTpv.productos &&
          firstTpv.productos.length > 0 &&
          firstTpv.productos[0].producto
        ) {
          const productoData = firstTpv.productos[0].producto;

          const esTarifaBD = productoData.PLU2 === "Tarifas";
          const bcTieneMultiplesUD =
            this.productoSeleccionado.udMedida &&
            this.productoSeleccionado.udMedida.length > 1;

          if (esTarifaBD && bcTieneMultiplesUD) {
            esTarifas = true;
          } else {
            esTarifas = false;
          }
        }
      }

      if (esTarifas && this.productoSeleccionado.changeFormatToRates === 0) {
        // Es un producto de tipo tarifas que continuará siendo de tipo tarifas
        // console.log("Estoy en esTarifas y no cambio");
        this.tarifasBloqueadas = true;

        // Recuperar el primer TPV data
        const tpvId = firstTpvId;
        const tpvData = this.productDataInfo.tpvs[tpvId];

        if (tpvData && tpvData.productos && tpvData.productos.length > 0) {
          const productoData = tpvData.productos[0].producto;
          // console.log("productoData", productoData);

          // Categoría enlazada del primer TPV, solo para la cabecera común del formulario.
          // Cada fila de productosPorTpv conserva la SUYA (ver el map de abajo).
          const grupoEnlazadoPrimerTpv = this.grupoEnlazadoGuardado(productoData);

          // Actualizar información básica del producto
          const productoUpdate = {
            // nombreProducto: productoData.name || this.producto.nombreProducto,
            nombreProducto: this.producto.nombreProducto,
            descripcion: productoData.description || this.producto.descripcion,
            codigoBarras: productoData.barCode || this.producto.codigoBarras,
            color: productoData.color || this.producto.color || "amarillo",
            orden: Number(productoData.orderCode) || this.producto.orden || 999,
            baja: productoData.active === "0" || this.producto.baja,
            descuento: productoData.descuento || this.producto.descuento,
            isMenu: productoData.isMenu || this.producto.isMenu,
            isClosed: productoData.isClosed || this.producto.isClosed,
            grupo_enlazado: grupoEnlazadoPrimerTpv,
            tipoIva: Number(productoData.vatType) || this.producto.tipoIva || 0
          };

          const existingPricesMap = {};

          for (let k = 1; k <= 4; k++) {
            const npm = productoData[`namePrice${k}`];
            const pr = productoData[`price${k}`];
            if (npm && npm.trim() !== "") {
              existingPricesMap[npm.trim().toUpperCase()] = Number(pr) || 0;
            }
          }

          if ((!productoData.namePrice1 || productoData.namePrice1.trim() === "") && productoData.price1) {
            const fallbackUnit = (productoData.PLU4 || "").trim().toUpperCase();
            if (existingPricesMap[fallbackUnit] === undefined) {
              existingPricesMap[fallbackUnit] = Number(productoData.price1) || 0;
            }
          }

          // Actualizar información básica del producto
          this.productoUpdate = {
            // nombreProducto: productoData.name || this.producto.nombreProducto,
            nombreProducto: this.producto.nombreProducto,
            descripcion: productoData.description || this.producto.descripcion,
            codigoBarras: productoData.barCode || this.producto.codigoBarras,
            color: productoData.color || this.producto.color || "amarillo",
            orden: Number(productoData.orderCode) || this.producto.orden || 999,
            baja: productoData.active === "0" || this.producto.baja,
            descuento: productoData.descuento || this.producto.descuento,
            isMenu: productoData.isMenu || this.producto.isMenu,
            isClosed: productoData.isClosed || this.producto.isClosed,
            grupo_enlazado: grupoEnlazadoPrimerTpv,
            tipoIva: Number(productoData.vatType) || this.producto.tipoIva || 0
          };

          // Actualizar el producto con la nueva información
          Object.assign(this.producto, productoUpdate);

          // Actualizar namePrice, selPrice y price para cada tarifa
          for (let i = 1; i <= 4; i++) {
            const namePriceKey = `namePrice${i}`;
            const selPriceKey = `selPrice${i}`;
            const priceKey = `price${i}`;

            if (i === 1 || productoData[`namePrice${i}`] || productoData[`selPrice${i}`]) {
              // Actualizar namePrice desde productData
              this.$set(this.producto, namePriceKey, productoData[`namePrice${i}`] || "");

              // Actualizar selPrice desde productData (convert "1" to true, others to false)
              const selPriceValue = productoData[`selPrice${i}`];
              this.$set(this.producto, selPriceKey, selPriceValue === "1");

              // Actualizar price si está disponible
              const priceValue = productoData[priceKey] !== undefined ?
                Number(productoData[priceKey]) :
                (i === 1 ? 0 : this.producto[priceKey] || 0);
              this.$set(this.producto, priceKey, priceValue);

              if (
                !this.crearMultiplesProductosByUdsMedida &&
                this.productoSeleccionado.udMedida &&
                this.productoSeleccionado.udMedida.length > 1
              ) {
                const udMedida = this.productoSeleccionado.udMedida;

                // Rellenar y bloquear namePrice1 a namePrice4 según las unidades de medida
                // Ahora Mapeando por NOMBRE para evitar que el precio de la Posición 1 se quede en la Posición 1 si la unidad cambia
                console.log("[CONFIG] udMedida:", udMedida);
                console.log("[CONFIG] existingPricesMap:", existingPricesMap);
                console.log("[CONFIG] BEFORE mapping - this.producto:", {
                  namePrice1: this.producto.namePrice1,
                  price1: this.producto.price1,
                  namePrice2: this.producto.namePrice2,
                  price2: this.producto.price2,
                  namePrice3: this.producto.namePrice3,
                  price3: this.producto.price3,
                  namePrice4: this.producto.namePrice4,
                  price4: this.producto.price4
                });

                for (let j = 1; j <= 4; j++) {
                  const npKey = `namePrice${j}`;
                  const spKey = `selPrice${j}`;
                  const pKey = `price${j}`;

                  if (j <= udMedida.length) {
                    const unitName = udMedida[j - 1];
                    const unitKey = unitName.trim().toUpperCase();
                    const mappedPrice = existingPricesMap[unitKey];

                    console.log(`[CONFIG] j=${j}, unitName=${unitName}, unitKey=${unitKey}, mappedPrice=${mappedPrice}`);

                    // Rellenar namePrice con la unidad de medida
                    this.$set(this.producto, npKey, unitName);
                    // Marcar selPrice como true
                    this.$set(this.producto, spKey, true);

                    // RECUPERAR PRECIO POR NOMBRE
                    // Prioritize mapped price from DB, otherwise keep what Object.assign or fallback gave us (usually 0 from BC)
                    if (existingPricesMap[unitKey] !== undefined) {
                      console.log(`[CONFIG] Setting ${pKey} = ${existingPricesMap[unitKey]} (found in map)`);
                      this.$set(this.producto, pKey, existingPricesMap[unitKey]);
                    } else {
                      console.log(`[CONFIG] Setting ${pKey} = 0 (not found in map)`);
                      this.$set(this.producto, pKey, 0);
                    }

                  } else {
                    // Dejar namePrice como "" y selPrice como false para tarifas sobrantes
                    this.$set(this.producto, npKey, "");
                    this.$set(this.producto, spKey, false);
                    this.$set(this.producto, pKey, 0);
                  }
                }

                console.log("[CONFIG] AFTER mapping - this.producto:", {
                  namePrice1: this.producto.namePrice1,
                  price1: this.producto.price1,
                  namePrice2: this.producto.namePrice2,
                  price2: this.producto.price2,
                  namePrice3: this.producto.namePrice3,
                  price3: this.producto.price3,
                  namePrice4: this.producto.namePrice4,
                  price4: this.producto.price4
                });

                // Romper el bucle exterior ya que hemos configurado todo dentro
                break;
              }

            } else {
              // Limpiar cualquier tarifa sobrante
              this.$set(this.producto, namePriceKey, "");
              this.$set(this.producto, selPriceKey, false);
              this.$set(this.producto, priceKey, 0);
            }
          }

          // Actualizar productosPorTpv si existe
          console.log("[CONFIG] About to update productosPorTpv, length:", this.productosPorTpv ? this.productosPorTpv.length : 'null');

          if (this.productosPorTpv && this.productosPorTpv.length > 0) {
            console.log("[CONFIG] Updating productosPorTpv with mapped prices");

            this.productosPorTpv = this.productosPorTpv.map(tpv => {
              // Cada TPV conserva SU IVA y SU categoría. Antes se les aplicaba a
              // todos el dato del primer TPV (productoData sale de firstTpvId), lo
              // que aplanaba lo que cada negocio tuviera configurado al editar.
              const propio = this.getProductoDataDeTpv(tpv.idTpvServer);

              const nuevoTpv = {
                ...tpv,
                tipoIva: this.ivaGuardado(propio, tpv.tipoIva),
                idCategory: propio
                  ? (Number(propio.idCategory) || 0)
                  : tpv.idCategory,
                // Y su propia categoría enlazada: antes se copiaba a todos la del primer TPV,
                // que es un id de otro TPV y en el TPV destino no existe o es otra familia.
                grupo_enlazado: propio ? this.grupoEnlazadoGuardado(propio) : tpv.grupo_enlazado,
              };

              for (let i = 1; i <= 4; i++) {
                nuevoTpv[`price${i}`] = this.producto[`price${i}`] || 0;
                nuevoTpv[`namePrice${i}`] = this.producto[`namePrice${i}`] || "";
                nuevoTpv[`selPrice${i}`] = this.producto[`selPrice${i}`] || false;
              }

              console.log("[CONFIG] Updated TPV entry:", {
                tpv: tpv.idTpvServer,
                namePrice1: nuevoTpv.namePrice1,
                price1: nuevoTpv.price1,
                namePrice2: nuevoTpv.namePrice2,
                price2: nuevoTpv.price2
              });

              return nuevoTpv;
            });
          }

          // Actualizar la UI
          this.actualizarCamposComunes();
          this.updateHeaders();
          // Tarifas: solo habilitar las tarifas correspondientes a las unidades de medida
          this.numTarifasActivas = this.productoSeleccionado.udMedida ? this.productoSeleccionado.udMedida.length : 1;
          return;
        }
      } else if (esTarifas && this.productoSeleccionado.changeFormatToRates === 1) {
        // Es un producto de tipo tarifas cuyas unidades de medida superan las máximas de Numier y 
        // deberá crearse como un producto independiente por cada unidad de medida (formatos)

        // console.log("Estoy en esTarifas y cambio a formatos");
        this.tarifasBloqueadas = true;

        // Recuperar el primer TPV data
        const tpvId = firstTpvId;
        const tpvData = this.productDataInfo.tpvs[tpvId];

        if (tpvData && tpvData.productos && tpvData.productos.length > 0) {
          // console.log("ES-1");
          const productoData = tpvData.productos[0].producto;
          // console.log("productoData", productoData);

          // Categoría enlazada del primer TPV, solo para la cabecera común del formulario.
          // Cada fila de productosPorTpv conserva la SUYA (ver el map de abajo).
          const grupoEnlazadoPrimerTpv = this.grupoEnlazadoGuardado(productoData);

          // Actualizar información básica del producto
          const productoUpdate = {
            // nombreProducto: productoData.name || this.producto.nombreProducto,
            nombreProducto: this.producto.nombreProducto,
            descripcion: productoData.description || this.producto.descripcion,
            codigoBarras: productoData.barCode || this.producto.codigoBarras,
            color: productoData.color || this.producto.color || "amarillo",
            orden: Number(productoData.orderCode) || this.producto.orden || 999,
            baja: productoData.active === "0" || this.producto.baja,
            descuento: productoData.descuento || this.producto.descuento,
            isMenu: productoData.isMenu || this.producto.isMenu,
            isClosed: productoData.isClosed || this.producto.isClosed,
            grupo_enlazado: grupoEnlazadoPrimerTpv,
            tipoIva: Number(productoData.vatType) || this.producto.tipoIva || 0
          };

          // Actualizar el producto con la nueva información
          Object.assign(this.producto, productoUpdate);

          // Actualizar productosPorTpv con datos de cada TPV
          if (this.productosPorTpv && this.productosPorTpv.length > 0) {
            this.productosPorTpv = this.productosPorTpv.map(tpv => {
              // Busco el productoDataInfo específico de ESTE TPV
              const tpvDataEspecifico = this.productDataInfo.tpvs[tpv.idTpvServer];

              if (tpvDataEspecifico && tpvDataEspecifico.productos && tpvDataEspecifico.productos.length > 0) {
                const productoDataEspecifico = tpvDataEspecifico.productos[0].producto;

                return {
                  ...tpv,
                  tipoIva: this.ivaGuardado(productoDataEspecifico, tpv.tipoIva),
                  idCategory: Number(productoDataEspecifico.idCategory) || 0,
                  // Categoría enlazada propia de este TPV (id de `categories` de este TPV)
                  grupo_enlazado: this.grupoEnlazadoGuardado(productoDataEspecifico),
                };
              }

              return tpv;
            })
          }

          // // Actualizar productosPorTpv si existe
          // if (this.productosPorTpv && this.productosPorTpv.length > 0) {
          //   // console.log("ES-2");
          //   // console.log("this.productosPorTpv", this.productosPorTpv);

          //   this.productosPorTpv = this.productosPorTpv.map(tpv => {
          //     console.log("actualizar productosPorTpv [2]", tpv);
          //     const nuevoTpv = {
          //       ...tpv,
          //       tipoIva: Number(productoData.vatType) || tpv.tipoIva || 0,
          //       idCategory: Number(productoData.idCategory) || tpv.idCategory,
          //       grupo_enlazado: String(grupoEnlazadoMapeado),
          //     };

          //     return nuevoTpv;
          //   });
          // }

          // Actualizar la UI
          this.actualizarCamposComunes();
          this.updateHeaders();
          this.numTarifasActivas = 1; // Formatos: cada formato es un producto independiente, solo 1 tarifa
          return;
        }
      } else {
        // console.log(" > configTarifasByUdsMedida por defecto");

        // Caso: Producto con varias unidades de medida (BC) y 1 solo producto
        if (
          !this.crearMultiplesProductosByUdsMedida &&
          this.productoSeleccionado.udMedida &&
          this.productoSeleccionado.udMedida.length > 1
        ) {
          const udMedida = this.productoSeleccionado.udMedida;

          // 1️⃣ Guardar nombres anteriores (los que venían de BD)
          const nombresAnteriores = {
            namePrice1: this.producto.namePrice1,
            namePrice2: this.producto.namePrice2,
            namePrice3: this.producto.namePrice3,
            namePrice4: this.producto.namePrice4,
          };

          // 2️⃣ Aplicar unidades de medida desde Business Central
          for (let i = 1; i <= 4; i++) {
            const namePriceKey = `namePrice${i}`;
            const selPriceKey = `selPrice${i}`;

            if (i <= udMedida.length) {
              this.$set(this.producto, namePriceKey, udMedida[i - 1]);
              this.$set(this.producto, selPriceKey, true);
            } else {
              this.$set(this.producto, namePriceKey, "");
              this.$set(this.producto, selPriceKey, false);
            }
          }

          // 3️⃣ Si la unidad ha cambiado → precio 0
          const preciosAntiguos = {};

          for (let i = 1; i <= 4; i++) {
            const nombre = nombresAnteriores[`namePrice${i}`];
            const precio = this.productoSeleccionado[`price${i}`];

            if (nombre) {
              preciosAntiguos[nombre] = precio;
            }
          }

          // Reasignar precios según nombre
          for (let i = 1; i <= 4; i++) {
            const nameKey = `namePrice${i}`;
            const priceKey = `price${i}`;

            const nombre = this.producto[nameKey];

            if (nombre && preciosAntiguos[nombre] !== undefined) {
              this.$set(this.producto, priceKey, preciosAntiguos[nombre]);
            } else {
              this.$set(this.producto, priceKey, 0);
            }
          }

          // Sincronizar la TABLA (productosPorTpv)
          if (this.productosPorTpv && this.productosPorTpv.length > 0) {
            this.productosPorTpv = this.productosPorTpv.map(tpv => {
              const nuevoTpv = { ...tpv };

              // Crear mapa de precios antiguos por nombre
              const preciosAntiguos = {};

              for (let i = 1; i <= 4; i++) {
                const nombre = nombresAnteriores[`namePrice${i}`];
                const precio = tpv[`price${i}`];

                if (nombre) {
                  preciosAntiguos[nombre] = precio;
                }
              }

              // Reasignar precios por nombre
              for (let i = 1; i <= 4; i++) {
                const nameKey = `namePrice${i}`;
                const priceKey = `price${i}`;

                const nombre = this.producto[nameKey];

                if (nombre && preciosAntiguos[nombre] !== undefined) {
                  nuevoTpv[priceKey] = preciosAntiguos[nombre];
                } else {
                  nuevoTpv[priceKey] = 0;
                }
              }

              return nuevoTpv;
            });
          }

        }

        // console.log("prodSeleccionado", this.productoSeleccionado);
        // console.log("prod", this.producto);
        // console.log("prodsporTPv", this.productosPorTpv);

        // Nuevo producto con varias unidades como tarifas: habilitar solo las tarifas con unidades
        if (
          this.productoSeleccionado &&
          this.productoSeleccionado.udMedida &&
          this.productoSeleccionado.udMedida.length > 1 &&
          !this.crearMultiplesProductosByUdsMedida
        ) {
          this.numTarifasActivas = this.productoSeleccionado.udMedida.length;
        } else if (
          this.crearMultiplesProductosByUdsMedida ||
          (this.productoSeleccionado && this.productoSeleccionado.udMedida && this.productoSeleccionado.udMedida.length === 1)
        ) {
          this.numTarifasActivas = 1; // Simple o formatos: solo 1 tarifa
        }
      }
    }
  },

  getNumTarifasActivas() {
    // Contar cuántos selPrice están en true
    let count = 0;
    for (let i = 1; i <= 4; i++) {
      if (this.producto[`selPrice${i}`]) {
        count++;
      }
    }
    // Asegurarse de que al menos haya 1 tarifa activa
    return Math.max(1, count);
  },

  configFormByListaCONySUPLEMENTO() {
    // console.log("iniciando configFormByListaCONySUPLEMENTO", this.productoSeleccionado);

    // Caso 1: Es CON y no SUPLEMENTO
    if (this.productoSeleccionado.MostrarEnListaCON === true && this.productoSeleccionado.MostrarEnListaSUPLEMENTO === false) {
      // 1.1 Settear y bloquear la categoría CON
      this.productosPorTpv.forEach((prod) => {
        const tpvData = this.categoryListBySelectedTpvServerList.find(t => t.tpvServer === String(prod.idTpvServer));
        if (tpvData && tpvData.categories) {
          const category = tpvData.categories.find(c => c.name === 'CON');
          if (category) {
            this.updateCategoryForTpv(prod.idTpvServer, category.id);
          }
        }
      });
      this.categoriasBloqueadas = true;

      // 1.2 Bloquear campos de tarifas y precios
      for (let i = 1; i <= 4; i++) {
        this.$set(this.producto, `namePrice${i}`, '');
        this.$set(this.producto, `selPrice${i}`, false);
        this.$set(this.producto, `price${i}`, 0);
      }
      this.actualizarCamposComunes();
      this.tarifasBloqueadas = true;
      this.numTarifasActivas = 0; // No se usan tarifas
    }
    // Caso 2: Es SUPLEMENTO y no CON
    else if (this.productoSeleccionado.MostrarEnListaCON === false && this.productoSeleccionado.MostrarEnListaSUPLEMENTO === true) {
      // 2.1 Settear y bloquear la categoría SUPLEMENTO
      this.productosPorTpv.forEach((prod) => {
        const tpvData = this.categoryListBySelectedTpvServerList.find(t => t.tpvServer === String(prod.idTpvServer));
        if (tpvData && tpvData.categories) {
          const category = tpvData.categories.find(c => c.name === 'SUPLEMENTO');
          if (category) {
            this.updateCategoryForTpv(prod.idTpvServer, category.id);
          }
        }
      });
      this.categoriasBloqueadas = true;

      // 2.2 Configurar y bloquear campos de tarifas
      this.$set(this.producto, 'namePrice1', 'SUPLEMENTO');
      this.$set(this.producto, 'selPrice1', false);
      this.$set(this.producto, 'price1', 0);
      for (let i = 2; i <= 4; i++) {
        this.$set(this.producto, `namePrice${i}`, '');
        this.$set(this.producto, `selPrice${i}`, false);
        this.$set(this.producto, `price${i}`, 0);
      }
      this.actualizarCamposComunes();
      this.tarifasBloqueadas = true;
      this.numTarifasActivas = 1; // Solo tarifa 1 activa
    }

    // Caso 3: Es CON y SUPLEMENTO
    else if (this.productoSeleccionado.MostrarEnListaCON === true && this.productoSeleccionado.MostrarEnListaSUPLEMENTO === true) {
      // console.log('Producto es tanto CON como SUPLEMENTO');

      if (!this.productosPorTpvRecuperados.length > 0) {
        // console.log(" > Datos recuperados encontrados, restaurando desde productosPorTpvRecuperados");

        // // Restaurar localProductosMultiples desde productosPorTpvRecuperados usando multiProductoIndex
        // const conData = this.productosPorTpvRecuperados.find(p => p.multiProductoIndex === 0);
        // const suplementoData = this.productosPorTpvRecuperados.find(p => p.multiProductoIndex === 1);

        // this.localProductosMultiples = [
        //   {
        //     label: 'CON',
        //     producto: {
        //       ...this.producto,
        //       nombreProducto: conData.nombreProducto || '',
        //       descripcion: conData.descripcion || this.producto.descripcion || '',
        //       codigoBarras: conData.codigoBarras || this.producto.codigoBarras || '',
        //       color: conData.color || this.producto.color || '',
        //       selPrice1: false,
        //       namePrice1: '',
        //       price1: 0,
        //       selPrice2: false,
        //       namePrice2: '',
        //       price2: 0,
        //       selPrice3: false,
        //       namePrice3: '',
        //       price3: 0,
        //       selPrice4: false,
        //       namePrice4: '',
        //       price4: 0,
        //       orden: conData.orden || 999,
        //       baja: conData.baja || false,
        //       descuento: conData.descuento || false,
        //       isMenu: conData.isMenu || false,
        //       isClosed: conData.isClosed || false,
        //       idCategory: conData.idCategory || null,
        //       tipoIva: (conData.tipoIva !== undefined && conData.tipoIva !== null) ? Number(conData.tipoIva) : null,
        //     },
        //   },
        //   {
        //     label: 'SUPLEMENTO',
        //     producto: {
        //       ...this.producto,
        //       nombreProducto: suplementoData.nombreProducto || '',
        //       descripcion: suplementoData.descripcion || this.producto.descripcion || '',
        //       codigoBarras: suplementoData.codigoBarras || this.producto.codigoBarras || '',
        //       color: suplementoData.color || this.producto.color || '',
        //       selPrice1: false,
        //       namePrice1: suplementoData.namePrice1 || 'SUPLEMENTO',
        //       price1: suplementoData.price1 || 0,
        //       selPrice2: false,
        //       namePrice2: '',
        //       price2: 0,
        //       selPrice3: false,
        //       namePrice3: '',
        //       price3: 0,
        //       selPrice4: false,
        //       namePrice4: '',
        //       price4: 0,
        //       orden: suplementoData.orden || 999,
        //       baja: suplementoData.baja || false,
        //       descuento: suplementoData.descuento || false,
        //       isMenu: suplementoData.isMenu || false,
        //       isClosed: suplementoData.isClosed || false,
        //       idCategory: suplementoData.idCategory || null,
        //       tipoIva: (suplementoData.tipoIva !== undefined && suplementoData.tipoIva !== null) ? Number(suplementoData.tipoIva) : null,
        //     },
        //   },
        // ];

        // // Restaurar productosPorTpv desde productosPorTpvRecuperados
        // this.productosPorTpv = this.productosPorTpvRecuperados.map(prod => ({
        //   ...prod,
        //   nombreProducto: prod.nombreProducto || "",
        //   descripcion: prod.descripcion || "",
        //   codigoBarras: prod.codigoBarras || "",
        //   color: prod.color || "",
        //   price1: prod.price1 || 0,
        //   price2: prod.price2 || 0,
        //   price3: prod.price3 || 0,
        //   price4: prod.price4 || 0,
        // }));

        // // Actualizar this.producto para la pestaña activa
        // this.producto = { ...this.localProductosMultiples[this.indexProductoActivo].producto };

        // // Configurar bloqueos
        // this.categoriasBloqueadas = true;
        // this.tarifasBloqueadas = true;
        // this.numTarifasActivas = this.indexProductoActivo === 0 ? 0 : 1; // 0 para CON, 1 para SUPLEMENTO

        // // Verificar cambios en los TPVs seleccionados
        // this.checkChangesSelectedTpvList();
        // } else {
        // console.log(" > No hay datos recuperados, inicializando nuevos productos");

        // Inicializar localProductosMultiples con dos tabs: CON y SUPLEMENTO
        this.localProductosMultiples = [
          {
            label: 'CON',
            producto: {
              ...this.producto,
              namePrice1: '', selPrice1: false, price1: 0,
              namePrice2: '', selPrice2: false, price2: 0,
              namePrice3: '', selPrice3: false, price3: 0,
              namePrice4: '', selPrice4: false, price4: 0,
            }
          },
          {
            label: 'SUPLEMENTO',
            producto: {
              ...this.producto,
              namePrice1: 'SUPLEMENTO', selPrice1: false, price1: 0,
              namePrice2: '', selPrice2: false, price2: 0,
              namePrice3: '', selPrice3: false, price3: 0,
              namePrice4: '', selPrice4: false, price4: 0,
            }
          },
        ];

        // Reiniciar productosPorTpv para incluir dos productos por idTpvServer
        const newProductosPorTpv = [];
        this.productosPorTpv.forEach((prod) => {
          const tpvData = this.categoryListBySelectedTpvServerList.find(t => t.tpvServer === String(prod.idTpvServer));
          if (tpvData && tpvData.categories) {
            // Producto CON
            const categoryCON = tpvData.categories.find(c => c.name === 'CON');
            const productoCON = {
              ...prod,
              multiProductoIndex: 0,
              idCategory: categoryCON ? categoryCON.id : null,
              namePrice1: '',
              selPrice1: false,
              price1: 0,
              namePrice2: '',
              selPrice2: false,
              price2: 0,
              namePrice3: '',
              selPrice3: false,
              price3: 0,
              namePrice4: '',
              selPrice4: false,
              price4: 0,
              nombreProducto: this.producto.nombreProducto,
              descripcion: this.producto.descripcion,
              codigoBarras: this.producto.codigoBarras,
              color: this.producto.color,
              PLU2: 'CON-SUPLEMENTO',
              PLU3: 'CON'
            };

            // Producto SUPLEMENTO
            const categorySUP = tpvData.categories.find(c => c.name === 'SUPLEMENTO');
            const productoSUP = {
              ...prod,
              multiProductoIndex: 1,
              idCategory: categorySUP ? categorySUP.id : null,
              namePrice1: 'SUPLEMENTO',
              selPrice1: false,
              price1: 0,
              namePrice2: '',
              selPrice2: false,
              price2: 0,
              namePrice3: '',
              selPrice3: false,
              price3: 0,
              namePrice4: '',
              selPrice4: false,
              price4: 0,
              nombreProducto: this.producto.nombreProducto,
              descripcion: this.producto.descripcion,
              codigoBarras: this.producto.codigoBarras,
              color: this.producto.color,
              PLU2: 'CON-SUPLEMENTO',
              PLU3: 'SUPLEMENTO'
            };

            newProductosPorTpv.push(productoCON, productoSUP);
          }
        });

        this.productosPorTpv = newProductosPorTpv;
        this.categoriasBloqueadas = true;
        this.tarifasBloqueadas = true;
        this.numTarifasActivas = this.indexProductoActivo === 0 ? 0 : 1; // 0 para CON, 1 para SUPLEMENTO

        // Actualizar producto activo según indexProductoActivo
        this.indexProductoActivo = 0; // Iniciar con tab CON
        this.producto = { ...this.localProductosMultiples[this.indexProductoActivo].producto };
      }
      else {
        // console.log(" > else configFormByListaCONySUPLEMENTO cuando productosPorTpvRecuperados.length es > 0");
        // Forzamos cambio de tab al último y luego al primero para activar el render
        const ultimoIndex = this.localProductosMultiples.length - 1;
        this.$nextTick(() => {
          this.indexProductoActivo = ultimoIndex;

          // Volvemos al primer tab después de un breve delay
          setTimeout(() => {
            this.indexProductoActivo = 0;
          }, 50);
        });
      }
    }
  },

  getCompanies() {
    var config = {
      params: {
        jwt: this.$store.getters.jwt
      },
      headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
    };

    let vm = this;
    return this.axios.get(this.$store.getters.apiUrl + "general/getCompaniesByUser", config)
      .then(function (response) {

        if (!vm.idCompany) {
          vm.idCompany = response.data.result[0].id;

          vm.getCompanyConfigs();

          // console.log("idCompany",vm.idCompany);
        }

      })
      .catch(function (error) {
        console.log(error);
      });
  },

  getCompanyConfigs() {
    var config = {
      params: {
        jwt: this.$store.getters.jwt,
        idCompany: this.idCompany
      },
      headers: { Authorization: "Bearer " + this.$store.getters.jwt },
    };
    let vm = this;
    return this.axios
      .get(
        this.$store.getters.apiUrl + "general/getCompanyConfigs",
        config
      )
      .then(function (response) {
        if (response.data.response) {
          vm.companyConfigs = response.data.result;

          vm.companyConfigs.forEach(function (x) {
            if (x.idConfig == "134") {
              vm.restriccionBusinessCentral = true;
            }
          });


        }
      })
      .catch(function (error) {
        console.log(error);
      });
  },


};
</script>

<style scoped>
.form-layout {
  display: flex;
}

/* Envoltorio del selector de categoría enlazada: el tooltip se ancla aquí para que
   se muestre también cuando el select está deshabilitado (falta la categoría principal). */
.grupo-enlazado-wrapper {
  display: block;
  width: 100%;
  cursor: not-allowed;
}

/* Un <input disabled> se traga los eventos de ratón y el envoltorio nunca recibe el
   mouseenter, así que el tooltip no salía. Con pointer-events: none el puntero pasa al
   envoltorio. Solo mientras el select está deshabilitado; habilitado se comporta igual que antes. */
.grupo-enlazado-wrapper /deep/ .el-select .el-input.is-disabled,
.grupo-enlazado-wrapper /deep/ .el-select .el-input.is-disabled .el-input__inner,
.grupo-enlazado-wrapper /deep/ .el-select .el-input.is-disabled .el-input__suffix {
  pointer-events: none;
}

.left-column,
.right-column {
  flex: 1;
}

.form-group {
  margin-bottom: 21px;
}

.form-group label {
  font-size: 15px;
}

.form-control {
  font-size: 15px;
  height: 28px;
}

.labels {
  font-size: 15px;
}

li {
  font-size: 15px;
}

.card {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 20px;
  background-color: white;
}

.card-title {
  margin-bottom: 15px;
}

.divider {
  border: none;
  height: 1px;
  background-color: #ccc;
  margin-top: 5px;
  margin-bottom: 25px;
  width: 100%;
}

.colors-form {
  text-align: left;
  justify-content: flex-start;
}

.color-options {
  display: flex;
  gap: 10px;
}

.radio {
  display: flex;
  align-items: center;
  gap: 5px;
}

.radio input[type="radio"] {
  width: 10px;
  height: 10px;
  margin-right: 3px;
  cursor: pointer;
}

.colorWrap {
  width: 42px;
  height: 42px;
  border: 1px solid #888;
  border-radius: 3px;
  float: right;
  cursor: pointer;
  /* display: inline-block;*/
}

.custom-checkbox {
  width: 17px;
  height: 17px;
  margin-right: 10px;
  cursor: pointer;
  appearance: none;
  border: 2px solid #a5a5a5;
  border-radius: 4px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease-in-out;
  margin-bottom: 9px;
}

.custom-checkbox:checked {
  background-color: #46c0bd;
  border: 2px solid #46c0bd;
}

.custom-checkbox:checked::after {
  content: "✔";
  color: white;
  font-size: 11px;
  font-weight: bold;
  position: absolute;
}

.custom-checkbox:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.alert-info {
  font-size: 20px;
  color: #0c5460 !important;
  background-color: #ffffff !important;
  border-color: #0c5460 !important;
  position: relative;
  padding-left: 45px;
  padding-right: 10px;
  padding-bottom: 2px !important;
  margin-top: 2px;
  margin-left: 0px;
  margin-right: 0px;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.55rem;
  box-sizing: border-box;
}

.fa-info-circle {
  position: absolute;
  left: 15px;
  top: 14px;
  right: 10px;
  bottom: 15px;
  font-size: 15px;
  color: #0c5460;
}

.table-container {
  width: 100%;
  margin-left: 0%;
  margin-right: 0%;
  overflow-x: auto;
  margin-top: 20px;
  margin-bottom: 30px;
}

.product-table {
  width: 100%;
  border-collapse: collapse;
  background-color: #ffffff;
}

.product-table th,
.product-table td {
  padding: 10px;
  border-bottom: 1px solid #ccc;
  text-align: left;
  font-size: 15px;
}

.product-table th {
  background-color: #ffffff;
}

.product-table input {
  width: 100px;
  text-align: right;
}

.tabs-multiples-productos {
  display: flex;
  margin-bottom: 15px;
  gap: 10px;
}

.tab {
  padding: 6px 12px;
  background: #ebeaea;
  border: 1px solid #c2c2c2;
  cursor: pointer;
  border-radius: 4px;
}

.tab.active {
  background: #fefefe;
  color: black;
  font-weight: bold;
  border: 2px solid #77b0e1;
}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Integraciones/BusinessCentral/Productos/ProductoFormBasico.vue